/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(372);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	var _smoothScroll = __webpack_require__(4);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	var _domready = __webpack_require__(5);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _hurdler = __webpack_require__(6);
	
	var _hurdler2 = _interopRequireDefault(_hurdler);
	
	var _accordion = __webpack_require__(7);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _promisePolyfill = __webpack_require__(8);
	
	var _promisePolyfill2 = _interopRequireDefault(_promisePolyfill);
	
	__webpack_require__(12);
	
	var _browserWarning = __webpack_require__(338);
	
	var _browserWarning2 = _interopRequireDefault(_browserWarning);
	
	var _section = __webpack_require__(340);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _globalHeader = __webpack_require__(341);
	
	var _globalHeader2 = _interopRequireDefault(_globalHeader);
	
	var _accordionDropdown = __webpack_require__(361);
	
	var _accordionDropdown2 = _interopRequireDefault(_accordionDropdown);
	
	var _formOverlay = __webpack_require__(362);
	
	var _formOverlay2 = _interopRequireDefault(_formOverlay);
	
	var _choiceTerms = __webpack_require__(363);
	
	var _choiceTerms2 = _interopRequireDefault(_choiceTerms);
	
	var _calculateMyBonus = __webpack_require__(364);
	
	var _calculateMyBonus2 = _interopRequireDefault(_calculateMyBonus);
	
	var _calculateMyBonusCta = __webpack_require__(368);
	
	var _calculateMyBonusCta2 = _interopRequireDefault(_calculateMyBonusCta);
	
	var _moveMyPoints = __webpack_require__(369);
	
	var _moveMyPoints2 = _interopRequireDefault(_moveMyPoints);
	
	var _videoModule = __webpack_require__(371);
	
	var _videoModule2 = _interopRequireDefault(_videoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hurdler = new _hurdler2.default();
	
	(0, _domready2.default)(function () {
	  if (!window.Promise) {
	    window.Promise = _promisePolyfill2.default;
	  }
	  // scroll to top of window on page load
	  window.onbeforeunload = function () {
	    window.scrollTo(0, 0);
	  };
	  // Initialize browser warning
	  document.queryAll('.browser-warning').forEach(function (element) {
	    new _browserWarning2.default({
	      element: element
	    });
	  });
	  // Initialize accordion component
	  document.queryAll('[data-component="accordion-dropdown"]').forEach(function (element) {
	    new _accordionDropdown2.default({
	      element: element
	    });
	  });
	  // Initialize choice terms component
	  document.queryAll('[data-component="choice-terms"]').forEach(function (element) {
	    new _choiceTerms2.default({
	      element: element
	    });
	  });
	  // Initialize global header
	  document.queryAll('[data-component="global-header"]').forEach(function (element) {
	    new _globalHeader2.default({
	      element: element,
	      hurdler: hurdler
	    });
	  });
	  // Initialize video-module
	  document.queryAll('[data-component="video-module"]').forEach(function (element) {
	    new _videoModule2.default({
	      element: element
	    });
	  });
	  // Initialize section component
	  document.queryAll('#move-my-points').forEach(function (element) {
	    new _moveMyPoints2.default({
	      element: element
	    });
	  });
	  // Initialize get-started cta
	  // document.queryAll('[data-component="get-started-cta"]').forEach(element => {
	  //   new GetStartedCta({
	  //     element
	  //   })
	  // })
	  // Initialize section component
	  document.queryAll('[data-component="section"]').forEach(function (element) {
	    new _section2.default({
	      element: element,
	      hurdler: hurdler
	    });
	  });
	  // Initialize calculate-my-bonus cta
	  document.queryAll('.calculate-my-bonus-cta').forEach(function (element) {
	    new _calculateMyBonusCta2.default({
	      element: element
	    });
	  });
	  // Initialize remind me later
	  document.queryAll('[data-component="remind-me-later"]').forEach(function (element) {
	    new RemindMeLater({
	      element: element
	    });
	  });
	  // Initialize form overlay
	  document.queryAll('[data-component="form-overlay"]').forEach(function (element) {
	    new _formOverlay2.default({
	      element: element
	    });
	  });
	  // Initialize calculate my bonus
	  document.queryAll('#calculate-my-bonus').forEach(function (element) {
	    new _calculateMyBonus2.default({
	      element: element
	    });
	  });
	
	  // Initialize smoothScroll
	  window.smoothScroll = new _smoothScroll2.default();
	  // Initialize Hurdler
	  hurdler.sprint();
	});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*!
	Copyright (C) 2013-2015 by Andrea Giammarchi - @WebReflection
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	
	*/
	(function(window){'use strict';
	  /* jshint loopfunc: true, noempty: false*/
	  // http://www.w3.org/TR/dom/#element
	
	  function createDocumentFragment() {
	    return document.createDocumentFragment();
	  }
	
	  function createElement(nodeName) {
	    return document.createElement(nodeName);
	  }
	
	  function enoughArguments(length, name) {
	    if (!length) throw new Error(
	      'Failed to construct ' +
	        name +
	      ': 1 argument required, but only 0 present.'
	    );
	  }
	
	  function mutationMacro(nodes) {
	    if (nodes.length === 1) {
	      return textNodeIfString(nodes[0]);
	    }
	    for (var
	      fragment = createDocumentFragment(),
	      list = slice.call(nodes),
	      i = 0; i < nodes.length; i++
	    ) {
	      fragment.appendChild(textNodeIfString(list[i]));
	    }
	    return fragment;
	  }
	
	  function textNodeIfString(node) {
	    return typeof node === 'string' ? document.createTextNode(node) : node;
	  }
	
	  for(var
	    head,
	    property,
	    TemporaryPrototype,
	    TemporaryTokenList,
	    wrapVerifyToken,
	    document = window.document,
	    hOP = Object.prototype.hasOwnProperty,
	    defineProperty = Object.defineProperty || function (object, property, descriptor) {
	      if (hOP.call(descriptor, 'value')) {
	        object[property] = descriptor.value;
	      } else {
	        if (hOP.call(descriptor, 'get'))
	          object.__defineGetter__(property, descriptor.get);
	        if (hOP.call(descriptor, 'set'))
	          object.__defineSetter__(property, descriptor.set);
	      }
	      return object;
	    },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    // http://www.w3.org/TR/domcore/#domtokenlist
	    verifyToken = function (token) {
	      if (!token) {
	        throw 'SyntaxError';
	      } else if (spaces.test(token)) {
	        throw 'InvalidCharacterError';
	      }
	      return token;
	    },
	    DOMTokenList = function (node) {
	      var
	        noClassName = typeof node.className === 'undefined',
	        className = noClassName ?
	          (node.getAttribute('class') || '') : node.className,
	        isSVG = noClassName || typeof className === 'object',
	        value = (isSVG ?
	          (noClassName ? className : className.baseVal) :
	          className
	        ).replace(trim, '')
	      ;
	      if (value.length) {
	        properties.push.apply(
	          this,
	          value.split(spaces)
	        );
	      }
	      this._isSVG = isSVG;
	      this._ = node;
	    },
	    classListDescriptor = {
	      get: function get() {
	        return new DOMTokenList(this);
	      },
	      set: function(){}
	    },
	    uid = 'dom4-tmp-'.concat(Math.random() * +new Date()).replace('.','-'),
	    trim = /^\s+|\s+$/g,
	    spaces = /\s+/,
	    SPACE = '\x20',
	    CLASS_LIST = 'classList',
	    toggle = function toggle(token, force) {
	      if (this.contains(token)) {
	        if (!force) {
	          // force is not true (either false or omitted)
	          this.remove(token);
	        }
	      } else if(force === undefined || force) {
	        force = true;
	        this.add(token);
	      }
	      return !!force;
	    },
	    DocumentFragmentPrototype = window.DocumentFragment && DocumentFragment.prototype,
	    Node = window.Node,
	    NodePrototype = (Node || Element).prototype,
	    CharacterData = window.CharacterData || Node,
	    CharacterDataPrototype = CharacterData && CharacterData.prototype,
	    DocumentType = window.DocumentType,
	    DocumentTypePrototype = DocumentType && DocumentType.prototype,
	    ElementPrototype = (window.Element || Node || window.HTMLElement).prototype,
	    HTMLSelectElement = window.HTMLSelectElement || createElement('select').constructor,
	    selectRemove = HTMLSelectElement.prototype.remove,
	    ShadowRoot = window.ShadowRoot,
	    SVGElement = window.SVGElement,
	    // normalizes multiple ids as CSS query
	    idSpaceFinder = / /g,
	    idSpaceReplacer = '\\ ',
	    createQueryMethod = function (methodName) {
	      var createArray = methodName === 'querySelectorAll';
	      return function (css) {
	        var a, i, id, query, nl, selectors, node = this.parentNode;
	        if (node) {
	          for (
	            id = this.getAttribute('id') || uid,
	            query = id === uid ? id : id.replace(idSpaceFinder, idSpaceReplacer),
	            selectors = css.split(','),
	            i = 0; i < selectors.length; i++
	          ) {
	            selectors[i] = '#' + query + ' ' + selectors[i];
	          }
	          css = selectors.join(',');
	        }
	        if (id === uid) this.setAttribute('id', id);
	        nl = (node || this)[methodName](css);
	        if (id === uid) this.removeAttribute('id');
	        // return a list
	        if (createArray) {
	          i = nl.length;
	          a = new Array(i);
	          while (i--) a[i] = nl[i];
	        }
	        // return node or null
	        else {
	          a = nl;
	        }
	        return a;
	      };
	    },
	    addQueryAndAll = function (where) {
	      if (!('query' in where)) {
	        where.query = ElementPrototype.query;
	      }
	      if (!('queryAll' in where)) {
	        where.queryAll = ElementPrototype.queryAll;
	      }
	    },
	    properties = [
	      'matches', (
	        ElementPrototype.matchesSelector ||
	        ElementPrototype.webkitMatchesSelector ||
	        ElementPrototype.khtmlMatchesSelector ||
	        ElementPrototype.mozMatchesSelector ||
	        ElementPrototype.msMatchesSelector ||
	        ElementPrototype.oMatchesSelector ||
	        function matches(selector) {
	          var parentNode = this.parentNode;
	          return !!parentNode && -1 < indexOf.call(
	            parentNode.querySelectorAll(selector),
	            this
	          );
	        }
	      ),
	      'closest', function closest(selector) {
	        var parentNode = this, matches;
	        while (
	          // document has no .matches
	          (matches = parentNode && parentNode.matches) &&
	          !parentNode.matches(selector)
	        ) {
	          parentNode = parentNode.parentNode;
	        }
	        return matches ? parentNode : null;
	      },
	      'prepend', function prepend() {
	        var firstChild = this.firstChild,
	            node = mutationMacro(arguments);
	        if (firstChild) {
	          this.insertBefore(node, firstChild);
	        } else {
	          this.appendChild(node);
	        }
	      },
	      'append', function append() {
	        this.appendChild(mutationMacro(arguments));
	      },
	      'before', function before() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.insertBefore(
	            mutationMacro(arguments), this
	          );
	        }
	      },
	      'after', function after() {
	        var parentNode = this.parentNode,
	            nextSibling = this.nextSibling,
	            node = mutationMacro(arguments);
	        if (parentNode) {
	          if (nextSibling) {
	            parentNode.insertBefore(node, nextSibling);
	          } else {
	            parentNode.appendChild(node);
	          }
	        }
	      },
	      // WARNING - DEPRECATED - use .replaceWith() instead
	      'replace', function replace() {
	        this.replaceWith.apply(this, arguments);
	      },
	      'replaceWith', function replaceWith() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.replaceChild(
	            mutationMacro(arguments),
	            this
	          );
	        }
	      },
	      'remove', function remove() {
	        var parentNode = this.parentNode;
	        if (parentNode) {
	          parentNode.removeChild(this);
	        }
	      },
	      'query', createQueryMethod('querySelector'),
	      'queryAll', createQueryMethod('querySelectorAll')
	    ],
	    slice = properties.slice,
	    i = properties.length; i; i -= 2
	  ) {
	    property = properties[i - 2];
	    if (!(property in ElementPrototype)) {
	      ElementPrototype[property] = properties[i - 1];
	    }
	    if (property === 'remove') {
	      // see https://github.com/WebReflection/dom4/issues/19
	      HTMLSelectElement.prototype[property] = function () {
	        return 0 < arguments.length ?
	          selectRemove.apply(this, arguments) :
	          ElementPrototype.remove.call(this);
	      };
	    }
	    // see https://github.com/WebReflection/dom4/issues/18
	    if (/^(?:before|after|replace|replaceWith|remove)$/.test(property)) {
	      if (CharacterData && !(property in CharacterDataPrototype)) {
	        CharacterDataPrototype[property] = properties[i - 1];
	      }
	      if (DocumentType && !(property in DocumentTypePrototype)) {
	        DocumentTypePrototype[property] = properties[i - 1];
	      }
	    }
	    // see https://github.com/WebReflection/dom4/pull/26
	    if (/^(?:append|prepend)$/.test(property)) {
	      if (DocumentFragmentPrototype) {
	        if (!(property in DocumentFragmentPrototype)) {
	          DocumentFragmentPrototype[property] = properties[i - 1];
	        }
	      } else {
	        try {
	          createDocumentFragment().constructor.prototype[property] = properties[i - 1];
	        } catch(o_O) {}
	      }
	    }
	  }
	
	  // bring query and queryAll to the document too
	  addQueryAndAll(document);
	
	  // brings query and queryAll to fragments as well
	  if (DocumentFragmentPrototype) {
	    addQueryAndAll(DocumentFragmentPrototype);
	  } else {
	    try {
	      addQueryAndAll(createDocumentFragment().constructor.prototype);
	    } catch(o_O) {}
	  }
	
	  // bring query and queryAll to the ShadowRoot too
	  if (ShadowRoot) {
	    addQueryAndAll(ShadowRoot.prototype);
	  }
	
	  // most likely an IE9 only issue
	  // see https://github.com/WebReflection/dom4/issues/6
	  if (!createElement('a').matches('a')) {
	    ElementPrototype[property] = function(matches){
	      return function (selector) {
	        return matches.call(
	          this.parentNode ?
	            this :
	            createDocumentFragment().appendChild(this),
	          selector
	        );
	      };
	    }(ElementPrototype[property]);
	  }
	
	  // used to fix both old webkit and SVG
	  DOMTokenList.prototype = {
	    length: 0,
	    add: function add() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(!this.contains(token)) {
	          properties.push.call(this, property);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    contains: (function(indexOf){
	      return function contains(token) {
	        i = indexOf.call(this, property = verifyToken(token));
	        return -1 < i;
	      };
	    }([].indexOf || function (token) {
	      i = this.length;
	      while(i-- && this[i] !== token){}
	      return i;
	    })),
	    item: function item(i) {
	      return this[i] || null;
	    },
	    remove: function remove() {
	      for(var j = 0, token; j < arguments.length; j++) {
	        token = arguments[j];
	        if(this.contains(token)) {
	          properties.splice.call(this, i, 1);
	        }
	      }
	      if (this._isSVG) {
	        this._.setAttribute('class', '' + this);
	      } else {
	        this._.className = '' + this;
	      }
	    },
	    toggle: toggle,
	    toString: function toString() {
	      return properties.join.call(this, SPACE);
	    }
	  };
	
	  if (SVGElement && !(CLASS_LIST in SVGElement.prototype)) {
	    defineProperty(SVGElement.prototype, CLASS_LIST, classListDescriptor);
	  }
	
	  // http://www.w3.org/TR/dom/#domtokenlist
	  // iOS 5.1 has completely screwed this property
	  // classList in ElementPrototype is false
	  // but it's actually there as getter
	  if (!(CLASS_LIST in document.documentElement)) {
	    defineProperty(ElementPrototype, CLASS_LIST, classListDescriptor);
	  } else {
	    // iOS 5.1 and Nokia ASHA do not support multiple add or remove
	    // trying to detect and fix that in here
	    TemporaryTokenList = createElement('div')[CLASS_LIST];
	    TemporaryTokenList.add('a', 'b', 'a');
	    if ('a\x20b' != TemporaryTokenList) {
	      // no other way to reach original methods in iOS 5.1
	      TemporaryPrototype = TemporaryTokenList.constructor.prototype;
	      if (!('add' in TemporaryPrototype)) {
	        // ASHA double fails in here
	        TemporaryPrototype = window.TemporaryTokenList.prototype;
	      }
	      wrapVerifyToken = function (original) {
	        return function () {
	          var i = 0;
	          while (i < arguments.length) {
	            original.call(this, arguments[i++]);
	          }
	        };
	      };
	      TemporaryPrototype.add = wrapVerifyToken(TemporaryPrototype.add);
	      TemporaryPrototype.remove = wrapVerifyToken(TemporaryPrototype.remove);
	      // toggle is broken too ^_^ ... let's fix it
	      TemporaryPrototype.toggle = toggle;
	    }
	  }
	
	  if (!('contains' in NodePrototype)) {
	    defineProperty(NodePrototype, 'contains', {
	      value: function (el) {
	        while (el && el !== this) el = el.parentNode;
	        return this === el;
	      }
	    });
	  }
	
	  if (!('head' in document)) {
	    defineProperty(document, 'head', {
	      get: function () {
	        return head || (
	          head = document.getElementsByTagName('head')[0]
	        );
	      }
	    });
	  }
	
	  // requestAnimationFrame partial polyfill
	  (function () {
	    for (var
	      raf,
	      rAF = window.requestAnimationFrame,
	      cAF = window.cancelAnimationFrame,
	      prefixes = ['o', 'ms', 'moz', 'webkit'],
	      i = prefixes.length;
	      !cAF && i--;
	    ) {
	      rAF = rAF || window[prefixes[i] + 'RequestAnimationFrame'];
	      cAF = window[prefixes[i] + 'CancelAnimationFrame'] ||
	            window[prefixes[i] + 'CancelRequestAnimationFrame'];
	    }
	    if (!cAF) {
	      // some FF apparently implemented rAF but no cAF 
	      if (rAF) {
	        raf = rAF;
	        rAF = function (callback) {
	          var goOn = true;
	          raf(function () {
	            if (goOn) callback.apply(this, arguments);
	          });
	          return function () {
	            goOn = false;
	          };
	        };
	        cAF = function (id) {
	          id();
	        };
	      } else {
	        rAF = function (callback) {
	          return setTimeout(callback, 15, 15);
	        };
	        cAF = function (id) {
	          clearTimeout(id);
	        };
	      }
	    }
	    window.requestAnimationFrame = rAF;
	    window.cancelAnimationFrame = cAF;
	  }());
	
	  // http://www.w3.org/TR/dom/#customevent
	  try{new window.CustomEvent('?');}catch(o_O){
	    window.CustomEvent = function(
	      eventName,
	      defaultInitDict
	    ){
	
	      // the infamous substitute
	      function CustomEvent(type, eventInitDict) {
	        /*jshint eqnull:true */
	        var event = document.createEvent(eventName);
	        if (typeof type != 'string') {
	          throw new Error('An event name must be provided');
	        }
	        if (eventName == 'Event') {
	          event.initCustomEvent = initCustomEvent;
	        }
	        if (eventInitDict == null) {
	          eventInitDict = defaultInitDict;
	        }
	        event.initCustomEvent(
	          type,
	          eventInitDict.bubbles,
	          eventInitDict.cancelable,
	          eventInitDict.detail
	        );
	        return event;
	      }
	
	      // attached at runtime
	      function initCustomEvent(
	        type, bubbles, cancelable, detail
	      ) {
	        /*jshint validthis:true*/
	        this.initEvent(type, bubbles, cancelable);
	        this.detail = detail;
	      }
	
	      // that's it
	      return CustomEvent;
	    }(
	      // is this IE9 or IE10 ?
	      // where CustomEvent is there
	      // but not usable as construtor ?
	      window.CustomEvent ?
	        // use the CustomEvent interface in such case
	        'CustomEvent' : 'Event',
	        // otherwise the common compatible one
	      {
	        bubbles: false,
	        cancelable: false,
	        detail: null
	      }
	    );
	  }
	
	  // window.Event as constructor
	  try { new Event('_'); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($Event) {
	      function Event(type, init) {
	        enoughArguments(arguments.length, 'Event');
	        var out = document.createEvent('Event');
	        if (!init) init = {};
	        out.initEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable
	        );
	        return out;
	      }
	      Event.prototype = $Event.prototype;
	      return Event;
	    }(window.Event || function Event() {}));
	    defineProperty(window, 'Event', {value: o_O});
	    // Android 4 gotcha
	    if (Event !== o_O) Event = o_O;
	  }
	
	  // window.KeyboardEvent as constructor
	  try { new KeyboardEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($KeyboardEvent) {
	      // code inspired by https://gist.github.com/termi/4654819
	      var
	        initType = 0,
	        defaults = {
	          char: '',
	          key: '',
	          location: 0,
	          ctrlKey: false,
	          shiftKey: false,
	          altKey: false,
	          metaKey: false,
	          altGraphKey: false,
	          repeat: false,
	          locale: navigator.language,
	          detail: 0,
	          bubbles: false,
	          cancelable: false,
	          keyCode: 0,
	          charCode: 0,
	          which: 0
	        },
	        eventType
	      ;
	      try {
	        var e = document.createEvent('KeyboardEvent');
	        e.initKeyboardEvent(
	          'keyup', false, false, window, '+', 3,
	          true, false, true, false, false
	        );
	        initType = (
	          (e.keyIdentifier || e.key) == '+' &&
	          (e.keyLocation || e.location) == 3
	        ) && (
	          e.ctrlKey ? e.altKey ? 1 : 3 : e.shiftKey ? 2 : 4
	        ) || 9;
	      } catch(o_O) {}
	      eventType = 0 < initType ? 'KeyboardEvent' : 'Event';
	
	      function getModifier(init) {
	        for (var
	          out = [],
	          keys = [
	            'ctrlKey',
	            'Control',
	            'shiftKey',
	            'Shift',
	            'altKey',
	            'Alt',
	            'metaKey',
	            'Meta',
	            'altGraphKey',
	            'AltGraph'
	          ],
	          i = 0; i < keys.length; i += 2
	        ) {
	          if (init[keys[i]])
	            out.push(keys[i + 1]);
	        }
	        return out.join(' ');
	      }
	
	      function withDefaults(target, source) {
	        for (var key in source) {
	          if (
	            source.hasOwnProperty(key) &&
	            !source.hasOwnProperty.call(target, key)
	          ) target[key] = source[key];
	        }
	        return target;
	      }
	
	      function withInitValues(key, out, init) {
	        try {
	          out[key] = init[key];
	        } catch(o_O) {}
	      }
	
	      function KeyboardEvent(type, init) {
	        enoughArguments(arguments.length, 'KeyboardEvent');
	        init = withDefaults(init || {}, defaults);
	        var
	          out = document.createEvent(eventType),
	          ctrlKey = init.ctrlKey,
	          shiftKey = init.shiftKey,
	          altKey = init.altKey,
	          metaKey = init.metaKey,
	          altGraphKey = init.altGraphKey,
	          modifiers = initType > 3 ? getModifier(init) : null,
	          key = String(init.key),
	          chr = String(init.char),
	          location = init.location,
	          keyCode = init.keyCode || (
	            (init.keyCode = key) &&
	            key.charCodeAt(0)
	          ) || 0,
	          charCode = init.charCode || (
	            (init.charCode = chr) &&
	            chr.charCodeAt(0)
	          ) || 0,
	          bubbles = init.bubbles,
	          cancelable = init.cancelable,
	          repeat = init.repeat,
	          locale = init.locale,
	          view = init.view || window,
	          args
	        ;
	        if (!init.which) init.which = init.keyCode;
	        if ('initKeyEvent' in out) {
	          out.initKeyEvent(
	            type, bubbles, cancelable, view,
	            ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode
	          );
	        } else if (0 < initType && 'initKeyboardEvent' in out) {
	          args = [type, bubbles, cancelable, view];
	          switch (initType) {
	            case 1:
	              args.push(key, location, ctrlKey, shiftKey, altKey, metaKey, altGraphKey);
	              break;
	            case 2:
	              args.push(ctrlKey, altKey, shiftKey, metaKey, keyCode, charCode);
	              break;
	            case 3:
	              args.push(key, location, ctrlKey, altKey, shiftKey, metaKey, altGraphKey);
	              break;
	            case 4:
	              args.push(key, location, modifiers, repeat, locale);
	              break;
	            default:
	              args.push(char, key, location, modifiers, repeat, locale);
	          }
	          out.initKeyboardEvent.apply(out, args);
	        } else {
	          out.initEvent(type, bubbles, cancelable);
	        }
	        for (key in out) {
	          if (defaults.hasOwnProperty(key) && out[key] !== init[key]) {
	            withInitValues(key, out, init);
	          }
	        }
	        return out;
	      }
	      KeyboardEvent.prototype = $KeyboardEvent.prototype;
	      return KeyboardEvent;
	    }(window.KeyboardEvent || function KeyboardEvent() {}));
	    defineProperty(window, 'KeyboardEvent', {value: o_O});
	    // Android 4 gotcha
	    if (KeyboardEvent !== o_O) KeyboardEvent = o_O;
	  }
	
	  // window.MouseEvent as constructor
	  try { new MouseEvent('_', {}); } catch (o_O) {
	    /* jshint -W022 */
	    o_O = (function ($MouseEvent) {
	      function MouseEvent(type, init) {
	        enoughArguments(arguments.length, 'MouseEvent');
	        var out = document.createEvent('MouseEvent');
	        if (!init) init = {};
	        out.initMouseEvent(
	          type,
	          !!init.bubbles,
	          !!init.cancelable,
	          init.view || window,
	          init.detail || 1,
	          init.screenX || 0,
	          init.screenY || 0,
	          init.clientX || 0,
	          init.clientY || 0,
	          !!init.ctrlKey,
	          !!init.altKey,
	          !!init.shiftKey,
	          !!init.metaKey,
	          init.button || 0,
	          init.relatedTarget || null
	        );
	        return out;
	      }
	      MouseEvent.prototype = $MouseEvent.prototype;
	      return MouseEvent;
	    }(window.MouseEvent || function MouseEvent() {}));
	    defineProperty(window, 'MouseEvent', {value: o_O});
	    // Android 4 gotcha
	    if (MouseEvent !== o_O) MouseEvent = o_O;
	  }
	
	}(window));(function (global){'use strict';
	
	  // a WeakMap fallback for DOM nodes only used as key
	  var DOMMap = global.WeakMap || (function () {
	
	    var
	      counter = 0,
	      dispatched = false,
	      drop = false,
	      value
	    ;
	
	    function dispatch(key, ce, shouldDrop) {
	      drop = shouldDrop;
	      dispatched = false;
	      value = undefined;
	      key.dispatchEvent(ce);
	    }
	
	    function Handler(value) {
	      this.value = value;
	    }
	
	    Handler.prototype.handleEvent = function handleEvent(e) {
	      dispatched = true;
	      if (drop) {
	        e.currentTarget.removeEventListener(e.type, this, false);
	      } else {
	        value = this.value;
	      }
	    };
	
	    function DOMMap() {
	      counter++;  // make id clashing highly improbable
	      this.__ce__ = new Event(('@DOMMap:' + counter) + Math.random());
	    }
	
	    DOMMap.prototype = {
	      'constructor': DOMMap,
	      'delete': function del(key) {
	        return dispatch(key, this.__ce__, true), dispatched;
	      },
	      'get': function get(key) {
	        dispatch(key, this.__ce__, false);
	        var v = value;
	        value = undefined;
	        return v;
	      },
	      'has': function has(key) {
	        return dispatch(key, this.__ce__, false), dispatched;
	      },
	      'set': function set(key, value) {
	        dispatch(key, this.__ce__, true);
	        key.addEventListener(this.__ce__.type, new Handler(value), false);
	        return this;
	      },
	    };
	
	    return DOMMap;
	
	  }());
	
	  function Dict() {}
	  Dict.prototype = (Object.create || Object)(null);
	
	  // https://dom.spec.whatwg.org/#interface-eventtarget
	
	  function createEventListener(type, callback, options) {
	    function eventListener(e) {
	      if (eventListener.once) {
	        e.currentTarget.removeEventListener(
	          e.type,
	          callback,
	          eventListener
	        );
	        eventListener.removed = true;
	      }
	      if (eventListener.passive) {
	        e.preventDefault = createEventListener.preventDefault;
	      }
	      if (typeof eventListener.callback === 'function') {
	        /* jshint validthis: true */
	        eventListener.callback.call(this, e);
	      } else if (eventListener.callback) {
	        eventListener.callback.handleEvent(e);
	      }
	      if (eventListener.passive) {
	        delete e.preventDefault;
	      }
	    }
	    eventListener.type = type;
	    eventListener.callback = callback;
	    eventListener.capture = !!options.capture;
	    eventListener.passive = !!options.passive;
	    eventListener.once = !!options.once;
	    // currently pointless but specs say to use it, so ...
	    eventListener.removed = false;
	    return eventListener;
	  }
	
	  createEventListener.preventDefault = function preventDefault() {};
	
	  var
	    Event = global.CustomEvent,
	    hOP = Object.prototype.hasOwnProperty,
	    dE = global.dispatchEvent,
	    aEL = global.addEventListener,
	    rEL = global.removeEventListener,
	    counter = 0,
	    increment = function () { counter++; },
	    indexOf = [].indexOf || function indexOf(value){
	      var length = this.length;
	      while(length--) {
	        if (this[length] === value) {
	          break;
	        }
	      }
	      return length;
	    },
	    getListenerKey = function (options) {
	      return ''.concat(
	        options.capture ? '1' : '0',
	        options.passive ? '1' : '0',
	        options.once ? '1' : '0'
	      );
	    },
	    augment, proto
	  ;
	
	  try {
	    aEL('_', increment, {once: true});
	    dE(new Event('_'));
	    dE(new Event('_'));
	    rEL('_', increment, {once: true});
	  } catch(o_O) {}
	
	  if (counter !== 1) {
	    (function () {
	      var dm = new DOMMap();
	      function createAEL(aEL) {
	        return function addEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key = getListenerKey(options),
	              i, tmp, wrap
	            ;
	            if (!info) dm.set(this, (info = new Dict()));
	            if (!(type in info)) info[type] = {
	              handler: [],
	              wrap: []
	            };
	            tmp = info[type];
	            i = indexOf.call(tmp.handler, handler);
	            if (i < 0) {
	              i = tmp.handler.push(handler) - 1;
	              tmp.wrap[i] = (wrap = new Dict());
	            } else {
	              wrap = tmp.wrap[i];
	            }
	            if (!(key in wrap)) {
	              wrap[key] = createEventListener(type, handler, options);
	              aEL.call(this, type, wrap[key], wrap[key].capture);
	            }
	          } else {
	            aEL.call(this, type, handler, options);
	          }
	        };
	      }
	      function createREL(rEL) {
	        return function removeEventListener(type, handler, options) {
	          if (options && typeof options !== 'boolean') {
	            var
	              info = dm.get(this),
	              key, i, tmp, wrap
	            ;
	            if (info && (type in info)) {
	              tmp = info[type];
	              i = indexOf.call(tmp.handler, handler);
	              if (-1 < i) {
	                key = getListenerKey(options);
	                wrap = tmp.wrap[i];
	                if (key in wrap) {
	                  rEL.call(this, type, wrap[key], wrap[key].capture);
	                  delete wrap[key];
	                  // return if there are other wraps
	                  for (key in wrap) return;
	                  // otherwise remove all the things
	                  tmp.handler.splice(i, 1);
	                  tmp.wrap.splice(i, 1);
	                  // if there are no other handlers
	                  if (tmp.handler.length === 0)
	                    // drop the info[type] entirely
	                    delete info[type];
	                }
	              }
	            }
	          } else {
	            rEL.call(this, type, handler, options);
	          }
	        };
	      }
	
	      augment = function (Constructor) {
	        if (!Constructor) return;
	        var proto = Constructor.prototype;
	        proto.addEventListener = createAEL(proto.addEventListener);
	        proto.removeEventListener = createREL(proto.removeEventListener);
	      };
	
	      if (global.EventTarget) {
	        augment(EventTarget);
	      } else {
	        augment(global.Text);
	        augment(global.Element || global.HTMLElement);
	        augment(global.HTMLDocument);
	        augment(global.Window || {prototype:global});
	        augment(global.XMLHttpRequest);
	      }
	
	    }());
	  }
	
	}(self));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*!
	 * @copyright Copyright (c) 2017 IcoMoon.io
	 * @license   Licensed under MIT license
	 *            See https://github.com/Keyamoon/svgxuse
	 * @version   1.2.6
	 */
	/*jslint browser: true */
	/*global XDomainRequest, MutationObserver, window */
	(function () {
	    "use strict";
	    if (typeof window !== "undefined" && window.addEventListener) {
	        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
	        var checkUseElems;
	        var tid; // timeout id
	        var debouncedCheck = function () {
	            clearTimeout(tid);
	            tid = setTimeout(checkUseElems, 100);
	        };
	        var unobserveChanges = function () {
	            return;
	        };
	        var observeChanges = function () {
	            var observer;
	            window.addEventListener("resize", debouncedCheck, false);
	            window.addEventListener("orientationchange", debouncedCheck, false);
	            if (window.MutationObserver) {
	                observer = new MutationObserver(debouncedCheck);
	                observer.observe(document.documentElement, {
	                    childList: true,
	                    subtree: true,
	                    attributes: true
	                });
	                unobserveChanges = function () {
	                    try {
	                        observer.disconnect();
	                        window.removeEventListener("resize", debouncedCheck, false);
	                        window.removeEventListener("orientationchange", debouncedCheck, false);
	                    } catch (ignore) {}
	                };
	            } else {
	                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
	                unobserveChanges = function () {
	                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
	                    window.removeEventListener("resize", debouncedCheck, false);
	                    window.removeEventListener("orientationchange", debouncedCheck, false);
	                };
	            }
	        };
	        var createRequest = function (url) {
	            // In IE 9, cross origin requests can only be sent using XDomainRequest.
	            // XDomainRequest would fail if CORS headers are not set.
	            // Therefore, XDomainRequest should only be used with cross origin requests.
	            function getOrigin(loc) {
	                var a;
	                if (loc.protocol !== undefined) {
	                    a = loc;
	                } else {
	                    a = document.createElement("a");
	                    a.href = loc;
	                }
	                return a.protocol.replace(/:/g, "") + a.host;
	            }
	            var Request;
	            var origin;
	            var origin2;
	            if (window.XMLHttpRequest) {
	                Request = new XMLHttpRequest();
	                origin = getOrigin(location);
	                origin2 = getOrigin(url);
	                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
	                    Request = XDomainRequest || undefined;
	                } else {
	                    Request = XMLHttpRequest;
	                }
	            }
	            return Request;
	        };
	        var xlinkNS = "http://www.w3.org/1999/xlink";
	        checkUseElems = function () {
	            var base;
	            var bcr;
	            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
	            var hash;
	            var href;
	            var i;
	            var inProgressCount = 0;
	            var isHidden;
	            var Request;
	            var url;
	            var uses;
	            var xhr;
	            function observeIfDone() {
	                // If done with making changes, start watching for chagnes in DOM again
	                inProgressCount -= 1;
	                if (inProgressCount === 0) { // if all xhrs were resolved
	                    unobserveChanges(); // make sure to remove old handlers
	                    observeChanges(); // watch for changes to DOM
	                }
	            }
	            function attrUpdateFunc(spec) {
	                return function () {
	                    if (cache[spec.base] !== true) {
	                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
	                        if (spec.useEl.hasAttribute("href")) {
	                            spec.useEl.setAttribute("href", "#" + spec.hash);
	                        }
	                    }
	                };
	            }
	            function onloadFunc(xhr) {
	                return function () {
	                    var body = document.body;
	                    var x = document.createElement("x");
	                    var svg;
	                    xhr.onload = null;
	                    x.innerHTML = xhr.responseText;
	                    svg = x.getElementsByTagName("svg")[0];
	                    if (svg) {
	                        svg.setAttribute("aria-hidden", "true");
	                        svg.style.position = "absolute";
	                        svg.style.width = 0;
	                        svg.style.height = 0;
	                        svg.style.overflow = "hidden";
	                        body.insertBefore(svg, body.firstChild);
	                    }
	                    observeIfDone();
	                };
	            }
	            function onErrorTimeout(xhr) {
	                return function () {
	                    xhr.onerror = null;
	                    xhr.ontimeout = null;
	                    observeIfDone();
	                };
	            }
	            unobserveChanges(); // stop watching for changes to DOM
	            // find all use elements
	            uses = document.getElementsByTagName("use");
	            for (i = 0; i < uses.length; i += 1) {
	                try {
	                    bcr = uses[i].getBoundingClientRect();
	                } catch (ignore) {
	                    // failed to get bounding rectangle of the use element
	                    bcr = false;
	                }
	                href = uses[i].getAttribute("href")
	                        || uses[i].getAttributeNS(xlinkNS, "href")
	                        || uses[i].getAttribute("xlink:href");
	                if (href && href.split) {
	                    url = href.split("#");
	                } else {
	                    url = ["", ""];
	                }
	                base = url[0];
	                hash = url[1];
	                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
	                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
	                    // the use element is empty
	                    // if there is a reference to an external SVG, try to fetch it
	                    // use the optional fallback URL if there is no reference to an external SVG
	                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
	                        base = fallback;
	                    }
	                    if (uses[i].hasAttribute("href")) {
	                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
	                    }
	                    if (base.length) {
	                        // schedule updating xlink:href
	                        xhr = cache[base];
	                        if (xhr !== true) {
	                            // true signifies that prepending the SVG was not required
	                            setTimeout(attrUpdateFunc({
	                                useEl: uses[i],
	                                base: base,
	                                hash: hash
	                            }), 0);
	                        }
	                        if (xhr === undefined) {
	                            Request = createRequest(base);
	                            if (Request !== undefined) {
	                                xhr = new Request();
	                                cache[base] = xhr;
	                                xhr.onload = onloadFunc(xhr);
	                                xhr.onerror = onErrorTimeout(xhr);
	                                xhr.ontimeout = onErrorTimeout(xhr);
	                                xhr.open("GET", base);
	                                xhr.send();
	                                inProgressCount += 1;
	                            }
	                        }
	                    }
	                } else {
	                    if (!isHidden) {
	                        if (cache[base] === undefined) {
	                            // remember this URL if the use element was not empty and no request was sent
	                            cache[base] = true;
	                        } else if (cache[base].onload) {
	                            // if it turns out that prepending the SVG is not necessary,
	                            // abort the in-progress xhr.
	                            cache[base].abort();
	                            delete cache[base].onload;
	                            cache[base] = true;
	                        }
	                    } else if (base.length && cache[base]) {
	                        setTimeout(attrUpdateFunc({
	                            useEl: uses[i],
	                            base: base,
	                            hash: hash
	                        }), 0);
	                    }
	                }
	            }
	            uses = "";
	            inProgressCount += 1;
	            observeIfDone();
	        };
	        var winLoad;
	        winLoad = function () {
	            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
	            tid = setTimeout(checkUseElems, 0);
	        };
	        if (document.readyState !== "complete") {
	            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
	            window.addEventListener("load", winLoad, false);
	        } else {
	            // No need to add a listener if the document is already loaded, initialize immediately.
	            winLoad();
	        }
	    }
	}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! smooth-scroll v12.1.5 | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */
	!(function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return t(e)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=t(e):e.SmoothScroll=t(e)})("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,(function(e){"use strict";var t="querySelector"in document&&"addEventListener"in e&&"requestAnimationFrame"in e&&"closest"in e.Element.prototype,n={ignore:"[data-scroll-ignore]",header:null,speed:500,offset:0,easing:"easeInOutCubic",customEasing:null,before:function(){},after:function(){}},o=function(){for(var e={},t=0,n=arguments.length;t<n;t++){var o=arguments[t];!(function(t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(o)}return e},a=function(t){return parseInt(e.getComputedStyle(t).height,10)},r=function(e){"#"===e.charAt(0)&&(e=e.substr(1));for(var t,n=String(e),o=n.length,a=-1,r="",i=n.charCodeAt(0);++a<o;){if(0===(t=n.charCodeAt(a)))throw new InvalidCharacterError("Invalid character: the input contains U+0000.");t>=1&&t<=31||127==t||0===a&&t>=48&&t<=57||1===a&&t>=48&&t<=57&&45===i?r+="\\"+t.toString(16)+" ":r+=t>=128||45===t||95===t||t>=48&&t<=57||t>=65&&t<=90||t>=97&&t<=122?n.charAt(a):"\\"+n.charAt(a)}return"#"+r},i=function(e,t){var n;return"easeInQuad"===e.easing&&(n=t*t),"easeOutQuad"===e.easing&&(n=t*(2-t)),"easeInOutQuad"===e.easing&&(n=t<.5?2*t*t:(4-2*t)*t-1),"easeInCubic"===e.easing&&(n=t*t*t),"easeOutCubic"===e.easing&&(n=--t*t*t+1),"easeInOutCubic"===e.easing&&(n=t<.5?4*t*t*t:(t-1)*(2*t-2)*(2*t-2)+1),"easeInQuart"===e.easing&&(n=t*t*t*t),"easeOutQuart"===e.easing&&(n=1- --t*t*t*t),"easeInOutQuart"===e.easing&&(n=t<.5?8*t*t*t*t:1-8*--t*t*t*t),"easeInQuint"===e.easing&&(n=t*t*t*t*t),"easeOutQuint"===e.easing&&(n=1+--t*t*t*t*t),"easeInOutQuint"===e.easing&&(n=t<.5?16*t*t*t*t*t:1+16*--t*t*t*t*t),e.customEasing&&(n=e.customEasing(t)),n||t},u=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},c=function(e,t,n){var o=0;if(e.offsetParent)do{o+=e.offsetTop,e=e.offsetParent}while(e);return o=Math.max(o-t-n,0)},s=function(e){return e?a(e)+e.offsetTop:0},l=function(t,n,o){o||(t.focus(),document.activeElement.id!==t.id&&(t.setAttribute("tabindex","-1"),t.focus(),t.style.outline="none"),e.scrollTo(0,n))},f=function(t){return!!("matchMedia"in e&&e.matchMedia("(prefers-reduced-motion)").matches)};return function(a,d){var m,h,g,p,v,b,y,S={};S.cancelScroll=function(){cancelAnimationFrame(y)},S.animateScroll=function(t,a,r){var f=o(m||n,r||{}),d="[object Number]"===Object.prototype.toString.call(t),h=d||!t.tagName?null:t;if(d||h){var g=e.pageYOffset;f.header&&!p&&(p=document.querySelector(f.header)),v||(v=s(p));var b,y,E,I=d?t:c(h,v,parseInt("function"==typeof f.offset?f.offset():f.offset,10)),O=I-g,A=u(),C=0,w=function(n,o){var r=e.pageYOffset;if(n==o||r==o||(g<o&&e.innerHeight+r)>=A)return S.cancelScroll(),l(t,o,d),f.after(t,a),b=null,!0},Q=function(t){b||(b=t),C+=t-b,y=C/parseInt(f.speed,10),y=y>1?1:y,E=g+O*i(f,y),e.scrollTo(0,Math.floor(E)),w(E,I)||(e.requestAnimationFrame(Q),b=t)};0===e.pageYOffset&&e.scrollTo(0,0),f.before(t,a),S.cancelScroll(),e.requestAnimationFrame(Q)}};var E=function(e){h&&(h.id=h.getAttribute("data-scroll-id"),S.animateScroll(h,g),h=null,g=null)},I=function(t){if(!f()&&0===t.button&&!t.metaKey&&!t.ctrlKey&&(g=t.target.closest(a))&&"a"===g.tagName.toLowerCase()&&!t.target.closest(m.ignore)&&g.hostname===e.location.hostname&&g.pathname===e.location.pathname&&/#/.test(g.href)){var n;try{n=r(decodeURIComponent(g.hash))}catch(e){n=r(g.hash)}if("#"===n){t.preventDefault(),h=document.body;var o=h.id?h.id:"smooth-scroll-top";return h.setAttribute("data-scroll-id",o),h.id="",void(e.location.hash.substring(1)===o?E():e.location.hash=o)}h=document.querySelector(n),h&&(h.setAttribute("data-scroll-id",h.id),h.id="",g.hash===e.location.hash&&(t.preventDefault(),E()))}},O=function(e){b||(b=setTimeout((function(){b=null,v=s(p)}),66))};return S.destroy=function(){m&&(document.removeEventListener("click",I,!1),e.removeEventListener("resize",O,!1),S.cancelScroll(),m=null,h=null,g=null,p=null,v=null,b=null,y=null)},S.init=function(a){t&&(S.destroy(),m=o(n,a||{}),p=m.header?document.querySelector(m.header):null,v=s(p),document.addEventListener("click",I,!1),e.addEventListener("hashchange",E,!1),p&&e.addEventListener("resize",O,!1))},S.init(d),S}}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';
	
	/*!
	 * Hurdler: https://github.com/jaydenseric/Hurdler
	 * @version v4.0.1
	 * @author Jayden Seric
	 * @license MIT
	 */
	
	/**
	 * Creates a new Hurdler session. There should only be one instance per window.
	 * @class
	 * @param {String} [$0.hashPrefix='/'] - String between URL hash symbol and target element ID to denote Hurdler links. Prevents auto scroll.
	 * @param {function} [$0.onSprintBefore] - Runs before each sprint.
	 * @param {function} [$0.onSprintAfter] - Runs after each sprint.
	 * @param {Hurdle[]} [$0.hurdles=[]] - List of hurdles.
	 * @example
	 * const hurdler = new Hurdler({
	 *   hashPrefix: '!/'
	 * })
	 */
	function Hurdler() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$hashPrefix = _ref.hashPrefix,
	      hashPrefix = _ref$hashPrefix === undefined ? '/' : _ref$hashPrefix,
	      onSprintBefore = _ref.onSprintBefore,
	      onSprintAfter = _ref.onSprintAfter,
	      _ref$hurdles = _ref.hurdles,
	      hurdles = _ref$hurdles === undefined ? [] : _ref$hurdles;
	
	  this.hashPrefix = hashPrefix;
	  this.onSprintBefore = onSprintBefore;
	  this.onSprintAfter = onSprintAfter;
	  this.hurdles = hurdles;
	
	  /**
	   * The current URL hash target element, or null if nonexistent.
	   * @type {HTMLElement|null}
	   * @example
	   * console.log(hurdler.target)
	   */
	  this.target = null;
	
	  // Sprint every URL hash change
	  window.addEventListener('hashchange', this.sprint.bind(this));
	}
	
	/**
	 * Adds a hurdle.
	 * @param {Hurdle} options - A hurdle.
	 * @example
	 * hurdler.addHurdle({
	 *   test: element => {
	 *     return element.tagName === 'SECTION'
	 *   },
	 *   onJump: element => {
	 *     console.log('Jumped a section', element)
	 *   }
	 * })
	 */
	Hurdler.prototype.addHurdle = function (options) {
	  this.hurdles.push(options);
	};
	
	/**
	 * Checks a provided URL hash matches the configured format.
	 * @param {string} hash - A URL hash to validate.
	 * @returns {boolean} URL hash validity.
	 * @example
	 * hurdler.validateHash(anExampleLinkElement.hash)
	 */
	Hurdler.prototype.validateHash = function (hash) {
	  // http://stackoverflow.com/a/4579228/1596978
	  return hash.lastIndexOf(this.hashPrefix, 0) === 0;
	};
	
	/**
	 * Gets the URL hash target element.
	 * @private
	 * @returns {HTMLElement|null} Element with the ID targeted, or null if nonexistent.
	 */
	Hurdler.prototype.getTarget = function () {
	  var hash = window.location.hash.split('#' + this.hashPrefix);
	  return hash.length === 2 ? document.getElementById(hash[1]) : null;
	};
	
	/**
	 * Sets the URL hash target element, triggering a sprint.
	 * @param {HTMLElement} element - Element with an ID to target.
	 * @example
	 * hurdler.setTarget(anExampleElement)
	 */
	Hurdler.prototype.setTarget = function (element) {
	  window.location.hash = this.hashPrefix + element.id;
	};
	
	/**
	 * Clears the window URL hash if a given element is targeted, or if the URL hash matches the configured Hurdler format.
	 * @param {HTMLElement} [element] - Element with an ID that you do not want targeted.
	 * @example
	 * hurdler.clearTarget(anExampleElement)
	 */
	Hurdler.prototype.clearTarget = function (element) {
	  if (element === undefined && this.validateHash(window.location.hash) || window.location.hash === '#' + this.hashPrefix + element.id) this.constructor.clearHash();
	};
	
	/**
	 * Jumps hurdles and runs callbacks for the current URL hash. Use after all hurdles have been added and the document is ready. Triggered automatically by URL hash changes.
	 * @example
	 * hurdler.sprint()
	 */
	Hurdler.prototype.sprint = function () {
	  var _this = this;
	
	  // Update the target DOM element
	  this.target = this.getTarget();
	  // Only sprint if there is a target to start at
	  if (this.target) {
	    (function () {
	      // Run before sprint callback
	      if (typeof _this.onSprintBefore === 'function') _this.onSprintBefore();
	      // Search from the target up the DOM for hurdles
	      var jumps = [];
	      var testElement = _this.target;
	      do {
	        // Test every hurdle against the element
	        _this.hurdles.forEach(function (hurdle) {
	          if (hurdle.test(testElement)) {
	            // Store hurdle jump for callbacks later
	            jumps.unshift({
	              element: testElement,
	              hurdle: hurdle
	            });
	          }
	        });
	      } while (testElement = testElement.parentElement);
	      // Run hurdle jump callbacks
	      jumps.forEach(function (jump) {
	        if (typeof jump.hurdle.onJump === 'function') jump.hurdle.onJump(jump.element);
	      });
	      // Run after sprint callback
	      if (typeof _this.onSprintAfter === 'function') _this.onSprintAfter();
	    })();
	  }
	};
	
	/**
	 * Clears the URL hash.
	 * @private
	 */
	Hurdler.clearHash = function () {
	  window.history.pushState('', document.title, window.location.pathname + window.location.search);
	};
	
	module.exports = Hurdler;
	//# sourceMappingURL=hurdler.js.map


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	(function(){
		"use strict";
	
		var touchEnabled = "ontouchstart" in document.documentElement;
		var pressEvent   = touchEnabled ? "touchend" : "click";
		var each         = [].forEach;
	
	
		/** Name of the onTransitionEnd event supported by this browser. */
		var transitionEnd = (function(){
			for(var names = "transitionend webkitTransitionEnd oTransitionEnd otransitionend".split(" "), i = 0; i < 4; ++i)
				if("on"+names[i].toLowerCase() in window) return names[i];
			return names[0];
		}());
		
		
		
		/**
		 * Conditionally add or remove a token from a token-list.
		 *
		 * @param {DOMTokenList} list
		 * @param {String} token
		 * @param {Boolean} enabled
		 */
		function setToken(list, token, enabled){
			enabled ? list.add(token) : list.remove(token);
		}
	
	
	
		/**
		 * Stop a function from firing too quickly.
		 *
		 * Returns a copy of the original function that runs only after the designated
		 * number of milliseconds have elapsed. Useful for throttling onResize handlers.
		 *
		 * @param {Number} limit - Threshold to stall execution by, in milliseconds.
		 * @param {Boolean} soon - If TRUE, will call the function *before* the threshold's elapsed, rather than after.
		 * @return {Function}
		 */
		function debounce(fn, limit, soon){
			var limit = limit < 0 ? 0 : limit,
				started, context, args, timer,
	
				delayed = function(){
	
					/** Get the time between now and when the function was first fired. */
					var timeSince = Date.now() - started;
	
					if(timeSince >= limit){
						if(!soon) fn.apply(context, args);
						if(timer) clearTimeout(timer);
						timer = context = args = null;
					}
	
					else timer = setTimeout(delayed, limit - timeSince);
				};
	
	
			/** Debounced copy of the original function. */
			return function(){
				context = this,
				args    = arguments;
	
				if(!limit)
					return fn.apply(context, args);
	
				started = Date.now();
				if(!timer){
					if(soon) fn.apply(context, args);
					timer = setTimeout(delayed, limit);
				}
			};
		};
	
	
	
		var uniqueID = (function(){
			var IDs     = {};
			var indexes = {};
			
			
			/**
			 * Generate a unique ID for a DOM element.
			 *
			 * By default, minimalist IDs like "_1" or "_2" are generated using internally
			 * tracked incrementation. Uglier, more collision-proof IDs can be generated by
			 * passing a truthy value to the function's first argument.
			 *
			 * Irrespective of whether values are being generated simply or randomly, the
			 * document tree is always consulted first to ensure a duplicate ID is never
			 * returned.
			 *
			 * @param {String}  prefix - Prefix prepended to result. Default: "_"
			 * @param {Boolean} random - Generate collision-proof IDs using random symbols
			 * @param {Number}  length - Length of random passwords. Default: 6
			 * @return {String}
			 */
			function uniqueID(prefix, complex, length){
				length     = +(length || 6);
				var result =  (prefix = prefix || "_");
				
				/** Simple IDs */
				if(!complex){
					
					/** Set this prefix's starting index if it's not been used yet */
					if(!indexes[prefix])
						indexes[prefix] = 0;
					
					result += ++indexes[prefix];
				}
				
				/** Uglier/safer IDs */
				else{
					var chars   = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
					chars      += chars.toLowerCase();
					result     += chars[ Math.round(Math.random() * (chars.length - 1)) ];
					chars      += "0123456789";
					
					while(result.length < length)
						result += chars[ Math.round(Math.random() * (chars.length - 1))];
				}
				
				return IDs[result] || document.getElementById(result)
					? uniqueID(prefix, complex)
					: (IDs[result] = true, result);
			}
			
			
			return uniqueID;
		}());
	
	
		/** Name of the CSSOM property used by this browser for CSS transforms */
		var cssTransform = (function(n){
			s = document.documentElement.style;
			if((prop = n.toLowerCase()) in s) return prop;
			for(var prop, s, p = "Webkit Moz Ms O Khtml", p = (p.toLowerCase() + p).split(" "), i = 0; i < 10; ++i)
				if((prop = p[i]+n) in s) return prop;
			return "";
		}("Transform"));
	
	
		/** Whether 3D transforms are supported by this browser */
		var css3DSupported = (function(propName){
			var e = document.createElement("div"), s = e.style,
			v = [["translateY(", ")"], ["translate3d(0,", ",0)"]]
			try{ s[propName] = v[1].join("1px"); } catch(e){}
			return v[+!!s[propName]] === v[1];
		}(cssTransform));
	
	
	
	
	
	
	
	
	
		var folds = [];
	
	
		/**
		 * Represents a single panel of togglable content inside an Accordion.
		 *
		 * @param {Accordion} accordion
		 * @param {HTMLElement} el
		 * @constructor
		 */
		var Fold = function(accordion, el){
			var THIS            = this;
			var heading         = el.firstElementChild;
			var content         = el.lastElementChild;
			var elClasses       = el.classList;
			var openClass       = accordion.openClass;
			var closeClass      = accordion.closeClass;
			var keysEnabled     = !accordion.noKeys;
			var useBorders      = accordion.useBorders;
			var useTransforms   = !accordion.noTransforms && cssTransform;
			var onToggle        = accordion.onToggle;
			var _disabled       = false;
			var _open, _y, _height, _ariaEnabled;
			var scrollX, scrollY;
			var onTouchStart;
			var onKeyDown;
			var onPress;
			
			
			Object.defineProperties(THIS, {
				fit: {value: fit},
				
				
				/** Add or remove relevant ARIA attributes from the fold's elements */
				ariaEnabled: {
					get: function(){ return _ariaEnabled; },
					set: function(input){
						if((input = !!input) !== !!_ariaEnabled){
							_ariaEnabled = input;
							
							/** Enable ARIA-attribute management */
							if(input){
								heading.setAttribute("role", "tab");
								content.setAttribute("role", "tabpanel");
								checkIDs();
								
								/** Update the attributes that're controlled by .open's setter */
								heading.setAttribute("aria-selected", !!_open);
								heading.setAttribute("aria-expanded", !!_open);
								content.setAttribute("aria-hidden",   !_open);
							}
							
							/** Disabling; remove all relevant attributes */
							else{
								heading.removeAttribute("role");
								heading.removeAttribute("aria-controls");
								heading.removeAttribute("aria-selected");
								heading.removeAttribute("aria-expanded");
								
								content.removeAttribute("role");
								content.removeAttribute("aria-labelledby");
								content.removeAttribute("aria-hidden");
							}
						}
					}
				},
	
				
				
				/** Whether or not the fold's currently opened */
				open: {
					
					get: function(){
						
						/** Derive the fold's opened state from the DOM if it's not been determined yet */
						if(undefined === _open){
							_open = elClasses.contains(openClass);
							setToken(elClasses, closeClass, !_open);
						}
						
						return _open;
					},
					
					
					set: function(input){
						if((input = !!input) !== _open){
							
							/** If an onToggle callback was specified, run it. Avoid doing anything if it returns false. */
							if("function" === typeof onToggle && false === onToggle.call(null, THIS, input))
								return;
							
							setToken(elClasses, openClass,   input);
							setToken(elClasses, closeClass, !input);
							_open = input;
							
							/** Update ARIA attributes */
							if(_ariaEnabled){
								heading.setAttribute("aria-selected",  input);
								heading.setAttribute("aria-expanded",  input);
								content.setAttribute("aria-hidden",   !input);
							}
							
							/** If this fold was closed when the screen resized, run a full update in case its contents were juggled around */
							if(THIS.needsRefresh){
								delete THIS.needsRefresh;
								accordion.refresh();
							}
							else accordion.update();
						}
					}
				},
				
				
				/** Whether the fold's been deactivated */
				disabled: {
					get: function(){ return _disabled },
					set: function(input){
						if((input = !!input) !== _disabled){
							var style = el.style;
							
							/** Deactivated */
							if(_disabled = input){
								style.height = null;
								useTransforms
									? (style[cssTransform] = null)
									: (style.top = null);
								
								touchEnabled && heading.removeEventListener("touchstart", onTouchStart);
								heading.removeEventListener(pressEvent, onPress);
								elClasses.remove(openClass, closeClass);
								if(onKeyDown){
									heading.removeEventListener("keydown", onKeyDown);
									heading.removeAttribute("tabindex");
								}
								
								if(_ariaEnabled){
									THIS.ariaEnabled = false;
									_ariaEnabled     = true;
								}
							}
							
							/** Reactivated */
							else{
								style.height = _height + "px";
								useTransforms
									? style[cssTransform] =
										css3DSupported
											? ("translate3D(0," + _y + "px,0)")
											: ("translateY("    + _y + "px)")
									: (style.top = _y + "px");
								
								touchEnabled && heading.addEventListener("touchstart", onTouchStart);
								heading.addEventListener(pressEvent, onPress);
								
								if(onKeyDown){
									heading.addEventListener("keydown", onKeyDown);
									heading.tabIndex = 0;
								}
							}
						}
					}
				},
				
				
				/** Vertical position of the fold within an accordion's container */
				y: {
					get: function(){
						if(undefined === _y)
							return (_y = parseInt(el.style.top) || 0);
						return _y;
					},
					
					set: function(input){
						if((input = +input) !== _y){
							_y = input;
							useTransforms
								? el.style[cssTransform] =
									css3DSupported
										? ("translate3D(0," + input + "px,0)")
										: ("translateY("    + input + "px)")
								: (el.style.top = input + "px");
						}
					}
				},
				
				
				/** Height of the fold's outermost container */
				height: {
					
					get: function(){
						if(undefined === _height){
							_height = THIS.headingHeight + content.scrollHeight;
							el.style.height = _height + "px";
						}
						return _height;
					},
					
					set: function(input){
						if(input && (input = +input) !== _height){
							el.style.height = input + "px"
							_height         = input;
						}
					}
				},
				
	
				/** Current height of the fold's heading */
				headingHeight: {
					get: function(){
						return heading.scrollHeight
							+ THIS.heightOffset
							+ (useBorders ? THIS.headingBorder : 0)
					}
				},
				
				/** Total height consumed by the heading element's CSS borders, if any */
				headingBorder: {
					get: function(){
						return (heading.offsetHeight || 0) - (heading.clientHeight || 0);
					}
				},
				
				
				
				/** Total height of the fold's container element */
				elHeight: {
					get: function(){
						return el.scrollHeight + (useBorders ? THIS.elBorder : 0);
					}
				},
				
				/** Total height consumed by container element's CSS borders, if any */
				elBorder: {
					get: function(){
						return (el.offsetHeight || 0) - (el.clientHeight || 0);
					}
				},
				
				
				/** Whether the fold's container has been resized incorrectly */
				wrongSize: {
					get: function(){
						return THIS.headingHeight + content.scrollHeight !== el.scrollHeight;
					}
				}
			});
			
			
			
			THIS.index        = folds.push(THIS) - 1;
			THIS.accordion    = accordion;
			THIS.el           = el;
			THIS.heading      = heading;
			THIS.content      = content;
			THIS.ariaEnabled  = !accordion.noAria;
			THIS.heightOffset = accordion.heightOffset;
			el.accordionFold  = THIS.index;
			useBorders        = "auto" === useBorders ? (0 !== THIS.elBorder + THIS.headingBorder) : useBorders;
			
			
			
			function checkIDs(){
				var headingSuffix = "-heading";
				var contentSuffix = "-content";
				var elID            = el.id;
				var id;
				
				/** Neither of the fold's elements have an ID attribute */
				if(!heading.id && !content.id){
					id             = elID || uniqueID("a");
					heading.id     = id + headingSuffix;
					content.id     = id + contentSuffix;
				}
				
				/** Either the heading or element lack an ID */
				else if(!content.id) content.id   = (elID || heading.id) + contentSuffix;
				else if(!heading.id) heading.id   = (elID || content.id) + headingSuffix;
				
				/** Finally, double-check each element's ID is really unique */
				var $ = function(s){return document.querySelectorAll("#"+s)};
				while($(content.id).length > 1 || $(heading.id).length > 1){
					id         = uniqueID("a");
					content.id = id + contentSuffix;
					heading.id = id + headingSuffix;
				}
				
				/** Update ARIA attributes */
				heading.setAttribute("aria-controls",    content.id);
				content.setAttribute("aria-labelledby",  heading.id);
			}
			
			
			
			/** Keyboard navigation */
			if(keysEnabled){
				heading.tabIndex = 0;
				heading.addEventListener("keydown", onKeyDown = function(e){
					var key = e.keyCode;
					var fold;
					
					switch(key){
						
						/** Enter: Toggle */
						case 13: {
							THIS.open = !THIS.open;
							break;
						}
						
						/** Escape: Clear focus */
						case 27:{
							e.target.blur();
							break;
						}
						
						
						/** Up arrow: Previous section */
						case 38:{
							
							/** Is there a previous sibling to navigate up to? */
							if(fold = THIS.previousFold){
								var children = fold.childAccordions;
								
								/** Is it open, and does it have nested accordions? */
								if(fold.open && children){
									var lastAcc;
									var lastFold;
									
									/** Locate the deepest/nearest accordion that's currently exposed */
									while(children){
										lastAcc  = children[children.length - 1];
										lastFold = lastAcc.folds[lastAcc.folds.length - 1];
										if(!lastFold.open) break;
										children = lastFold.childAccordions;
									}
									
									lastFold.heading.focus();
								}
								
								/** Nope */
								else fold.heading.focus();
							}
							
							/** Is there a higher level we can jump back up to? */
							else if(accordion.parent)
								accordion.parentFold.heading.focus();
							
							/** There's nothing to move back to, so just let the browser run its usual behaviour */
							else return true;
							
							e.preventDefault();
							return false;
						}
						
						
						
						/** Down arrow: Next section */
						case 40:{
							var children = THIS.childAccordions;
							
							/** Is there a nested accordion to jump into? */
							if(THIS.open && children)
								children[0].folds[0].heading.focus();
							
							/** No, there isn't. Is there another sibling to move down to? */
							else if(fold = THIS.nextFold)
								fold.heading.focus();
							
							/** Is there a containing accordion we can navigate back up to? */
							else if(THIS.accordion.parent){
								var parent = THIS;
								while(parent = parent.accordion.parentFold)
									if(fold = parent.nextFold){
										fold.heading.focus();
										break;
									}
								
								/** Nowhere left to go... */
								if(!parent) return true;
							}
							
							/** Nah. Just scroll the window normally, as per browser default */
							else return true;
							
							e.preventDefault();
							return false;
						}
						
						
						/** Left arrow */
						case 37:{
							
							/** Close an opened section */
							if(THIS.open) THIS.open = false;
							
							/** Switch focus back to parent */
							else if(accordion.parent)
								accordion.parentFold.heading.focus();
							
							break;
						}
						
						/** Right arrow */
						case 39:{
							var children = THIS.childAccordions;
							
							/** Open a closed section */
							if(!THIS.open) THIS.open = true;
							
							/** Switch focus to a nested accordion */
							else if(children)
								children[0].folds[0].heading.focus();
							
							break;
						}
					}
				});
			}
			
			
			/** Listener to record the viewport's scroll offsets at the beginning of a touch */
			touchEnabled && heading.addEventListener("touchstart", onTouchStart = function(e){
				scrollX = window.pageXOffset;
				scrollY = window.pageYOffset;
			});
			
			
			heading.addEventListener(pressEvent, onPress = function(e){
				if(e.type !== "touchend" || (e.cancelable && window.pageXOffset === scrollX && window.pageYOffset === scrollY)){
					THIS.open = !THIS.open;
					e.preventDefault();
				}
				return false;
			});
			
			
			
			
			/**
			 * Adjust a fold's container to fit its content.
			 */
			function fit(){
				var height = THIS.headingHeight;
				if(THIS.open)   height += content.scrollHeight;
				if(useBorders)  height += THIS.elBorder;
				THIS.height = height;
			}
		}
	
	
	
	
	
	
	
		var accordions       = [];
		var activeAccordions = 0;
		var lastResizeRate;
	
	
		/**
		 * Represents a column of collapsible content regions.
		 *
		 * @param {HTMLElement} el                    - Container wrapped around each immediate fold
		 * @param {Object}      options               - Optional hash of settings
		 * @param {String}      options.openClass     - CSS class controlling each fold's "open" state
		 * @param {String}      options.closeClass    - CSS class used to mark a fold as closed
		 * @param {String}      options.edgeClass     - CSS class toggled based on whether the bottom-edge is visible
		 * @param {String}      options.snapClass     - CSS class for disabling transitions between window resizes
		 * @param {String}      options.enabledClass  - CSS class marking an accordion as enabled
		 * @param {String}      options.disabledClass - CSS class marking an accordion as disabled
		 * @param {Boolean}     options.disabled      - Whether to disable the accordion on creation
		 * @param {Boolean}     options.noAria        - Disable the addition and management of ARIA attributes
		 * @param {Boolean}     options.noKeys        - Disable keyboard navigation
		 * @param {Boolean}     options.noTransforms  - Disable CSS transforms; positioning will be used instead
		 * @param {Number}      options.heightOffset  - Distance to offset each fold by
		 * @param {Boolean}     options.useBorders    - Consider borders when calculating fold heights
		 * @param {Function}    options.onToggle      - Callback executed when opening or closing a fold
		 * @constructor
		 */
		var Accordion = function(el, options){
			var THIS          = this;
			var elClasses     = el.classList;
			var options       = options || {};
			var edgeClass     = (undefined === options.edgeClass    ? "edge-visible" : options.edgeClass);
			var snapClass     = (undefined === options.snapClass    ? "snap"         : options.snapClass);
			var enabledClass  = (undefined === options.enabledClass ? "accordion"    : options.enabledClass);
			var disabledClass = options.disabledClass;
			var _height, _disabled, _parent, _parentFold;
	
	
			Object.defineProperties(THIS, {
				update:     {value: update},
				updateFold: {value: updateFold},
				refresh:    {value: refresh},
				
				/** Whether the accordion's been deactivated */
				disabled: {
					get: function(){ return _disabled; },
					set: function(input){
						if((input = !!input) !== _disabled){
							var style   = el.style;
							var folds   = THIS.folds;
							
							enabledClass  && setToken(elClasses, enabledClass,  !input);
							disabledClass && setToken(elClasses, disabledClass,  input);
							
							
							/** Deactivating */
							if(_disabled = input){
								style.height = null;
								snapClass && elClasses.remove(snapClass);
								if(edgeClass){
									el.removeEventListener(transitionEnd, THIS.onTransitionEnd);
									elClasses.remove(edgeClass);
								}
								
								for(var i = 0, l = folds.length; i < l; ++i)
									folds[i].disabled = true;
								
								THIS.noAria || el.removeAttribute("role");
								--activeAccordions;
							}
							
							
							/** Reactivating */
							else{
								for(var i = 0, l = folds.length; i < l; ++i)
									folds[i].disabled = false;
								
								THIS.noAria || el.setAttribute("role", "tablist");
								++activeAccordions;
								update();
							}
							
	
							
							/** If there're no more active accordions, disable the onResize handler */
							if(activeAccordions <= 0){
								activeAccordions = 0;
								Accordion.setResizeRate(false);
							}
							
							/** Otherwise, reactivate the onResize handler, assuming it was previously active */
							else if(lastResizeRate)
								Accordion.setResizeRate(lastResizeRate);
						}
					}
				},
				
				/** Get or set the accordion enclosing this one */
				parent: {
					set: function(input){ _parent = input; },
					get: function(){
						var result = _parent;
						if(!result) return null;
						
						/** Search for the first ancestor that *isn't* disabled */
						while(result){
							if(!result.disabled) return result;
							result = result.parent;
						}
						return null;
					}
				},
				
				/** Get or set the fold of the accordion enclosing this one */
				parentFold: {
					set: function(input){ _parentFold = input; },
					get: function(){
						var fold = _parentFold;
						if(!fold) return null;
						
						var accordion = fold.accordion;
						
						/** Search for the first ancestor that *isn't* disabled */
						while(fold && accordion){
							if(!accordion.disabled) return fold;
							if(accordion = accordion.parent)
								fold = accordion.parentFold;
						}
						return null;
					}
				},
				
				/** Height of the accordion's container element */
				height: {
					get: function(){ return _height; },
					set: function(input){
						if(input && (input = +input) !== _height){
							el.style.height = input + "px";
							_height         = input;
						}
					}
				},
				
				/** Whether one of the Accordion's folds has been resized incorrectly */
				wrongSize: {
					get: function(){
						var a = this.folds;
						var l = a.length;
						var i = 0;
						for(; i < l; ++i) if(a[i].wrongSize) return true;
						if(a = this.childAccordions)
						for(; i < l; ++i) if(a[i].wrongSize) return true;
						return false;
					}
				},
				
				/** Top-level ancestor this accordion's nested inside */
				root: {
					get: function(){
						var result = this;
						while(result){
							if(!result.parent) return result;
							result = result.parent;
						}
					}
				}
			});
	
			
			/** Assign options as properties */
			THIS.openClass    = options.openClass  || "open";
			THIS.closeClass   = options.closeClass || "closed";
			THIS.noAria       = !!options.noAria;
			THIS.noKeys       = !!options.noKeys;
			THIS.noTransforms = !!options.noTransforms;
			THIS.index        = accordions.push(THIS) - 1;
			THIS.heightOffset = +options.heightOffset || 0;
			THIS.useBorders   = undefined === options.useBorders ? "auto" : options.useBorders;
			THIS.onToggle     = options.onToggle;
			
			
			/** Create a fold for each immediate descendant of the Accordion's container */
			var folds = [];
			each.call(el.children, function(i){
				var fold = new Fold(THIS, i);
				folds.push(fold);
				
				/** Connect the fold to its previous sibling, if it's not the first to be added */
				var prev = folds[folds.length - 2];
				if(prev){
					prev.nextFold     = fold;
					fold.previousFold = prev;
				}
			});
			
			
			el.accordion    = THIS.index;
			THIS.noAria || el.setAttribute("role", "tablist");
			THIS.el         = el;
			THIS.folds      = folds;
			
			/** Add .enabledClass early - it might affect the heights of each fold */
			if(!options.disabled && enabledClass)
				elClasses.add(enabledClass);
			
			update();
			
			
			/** Find out if this accordion's nested inside another */
			var next = el;
			while((next = next.parentNode) && 1 === next.nodeType){
				var fold = Accordion.getFold(next);
				if(fold){
					var accordion   = fold.accordion;
					THIS.parent     = accordion;
					THIS.parentFold = fold;
					edgeClass && elClasses.remove(edgeClass);
					(accordion.childAccordions = accordion.childAccordions || []).push(THIS);
					(fold.childAccordions      = fold.childAccordions      || []).push(THIS);
	
					/** Adjust the height of the containing fold's element */
					if(fold.open){
						var scrollHeight = fold.el.scrollHeight;
						var distance     = (fold.headingHeight + fold.content.scrollHeight) - scrollHeight || (scrollHeight - fold.el.clientHeight);
						accordion.updateFold(fold, distance);
					}
					break;
				}
			}
			
			
			edgeClass && el.addEventListener(transitionEnd, this.onTransitionEnd = function(e){
				if(!THIS.parent && e.target === el && "height" === e.propertyName && el.getBoundingClientRect().bottom > window.innerHeight)
					elClasses.remove(edgeClass);
			});
			
			this.disabled = !!options.disabled;
			
			
			
			/**
			 * Internal method to check if an accordion's bottom-edge is visible to the user (or about to be).
			 *
			 * @param {Number} offset
			 * @private
			 */
			function edgeCheck(offset){
				if(edgeClass){
					var box         = el.getBoundingClientRect();
					var windowEdge  = window.innerHeight;
					
					/** If the bottom-edge is visible (or about to be), enable height animation */
					if(box.bottom + (offset || 0) < windowEdge)
						elClasses.add(edgeClass)
					
					/** If the bottom-edge isn't visible anyway, disable height animation immediately */
					else if(box.bottom > windowEdge)
						elClasses.remove(edgeClass);
				}
			}
			
			
			
			/**
			 * Update the vertical ordinate of each sibling for a particular fold.
			 *
			 * @param {Fold} fold
			 * @param {Number} offset - Pixel distance to adjust by
			 */
			function updateFold(fold, offset){
				var next = fold;
				var parentFold = THIS.parentFold;
				
				while(next = next.nextFold)
					next.y  += offset;
				parentFold || edgeCheck(offset);
				fold.height += offset;
				THIS.height += offset;
				
				parentFold && parentFold.open && THIS.parent.updateFold(parentFold, offset);
			}
			
			
			/**
			 * Update the height of each fold to fit its content.
			 */
			function update(){
				var y      = 0;
				var height = 0;
				var i      = 0;
				var l      = folds.length;
				var parentFold = THIS.parentFold;
				var fold, diff;
				
				for(; i < l; ++i){
					fold   = folds[i];
					fold.y = y;
					fold.fit();
					y      += fold.height;
					height += fold.height;
				}
				
				diff = height - _height;
				parentFold
					? (parentFold.open && THIS.parent.updateFold(parentFold, diff))
					: edgeCheck(diff);
				
				THIS.height = height;
			}
			
			
			
			/**
			 * Recalculate the boundaries of an Accordion and its descendants.
			 *
			 * This method should only be called if the width of a container changes,
			 * or a fold's contents have resized unexpectedly (such as when images load).
			 *
			 * @param {Boolean} allowSnap - Snap folds instantly into place without transitioning
			 */
			function refresh(allowSnap){
				var snap = allowSnap ? snapClass : false;
				snap && elClasses.add(snap);
				
				THIS.update();
				THIS.childAccordions && THIS.childAccordions.forEach(function(a){
					a.parentFold.open
						? a.refresh(allowSnap)
						: (a.parentFold.needsRefresh = true);
				});
				
				snap && setTimeout(function(e){elClasses.remove(snap)}, 20);
			}
		}
	
		/** If IE8PP exists, it means the author wants/needs IE8 support. See also: tinyurl.com/fixIE8-9 */
		if("function" === typeof IE8PP)
			Accordion = IE8PP(Accordion),
			Fold      = IE8PP(Fold);
	
	
	
		/**
		 * Alter the rate at which screen-resize events update accordion widths.
		 *
		 * @param {Number} delay - Rate expressed in milliseconds
		 */
		Accordion.setResizeRate = function(delay){
			var fn = function(e){
				for(var a, i = 0, l = accordions.length; i < l; ++i){
					a = accordions[i];
					a.parent || a.disabled || a.refresh(true);
				}
			};
			
			var THIS = Accordion;
			THIS.onResize && window.removeEventListener("resize", THIS.onResize);
			
			/** Make sure we weren't passed an explicit value of FALSE, or a negative value */
			if(false !== delay && (delay = +delay || 0) >= 0){
				THIS.onResize = delay ? debounce(fn, delay) : fn;
				window.addEventListener("resize", THIS.onResize);
				if(delay) lastResizeRate = delay;
			}
		}
		
		
		
		/**
		 * Return the closest (most deeply-nested) accordion enclosing an element.
		 *
		 * @param {Node} node
		 * @return {Accordion}
		 */
		Accordion.getAccordion = function(node){
			while(node){
				if("accordion" in node)
					return accordions[node.accordion];
				
				node = node.parentNode;
				if(!node || node.nodeType !== 1) return null;
			}
		}
		
		
		/**
		 * Return the closest (most deeply-nested) fold enclosing an element.
		 *
		 * @param {Node} node
		 * @return {Fold}
		 */
		Accordion.getFold = function(node){
			while(node){
				if("accordionFold" in node)
					return folds[node.accordionFold];
				
				node = node.parentNode;
				if(!node || node.nodeType !== 1) return null;
			}
		}
		
	
		
		Accordion.setResizeRate(25);
		
		
		/** Export */
		window.Accordion = Accordion;
	}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
	
	  // Store setTimeout reference so promise-polyfill will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var setTimeoutFunc = setTimeout;
	
	  function noop() {}
	  
	  // Polyfill for Function.prototype.bind
	  function bind(fn, thisArg) {
	    return function () {
	      fn.apply(thisArg, arguments);
	    };
	  }
	
	  function Promise(fn) {
	    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
	    if (typeof fn !== 'function') throw new TypeError('not a function');
	    this._state = 0;
	    this._handled = false;
	    this._value = undefined;
	    this._deferreds = [];
	
	    doResolve(fn, this);
	  }
	
	  function handle(self, deferred) {
	    while (self._state === 3) {
	      self = self._value;
	    }
	    if (self._state === 0) {
	      self._deferreds.push(deferred);
	      return;
	    }
	    self._handled = true;
	    Promise._immediateFn(function () {
	      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	      if (cb === null) {
	        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	        return;
	      }
	      var ret;
	      try {
	        ret = cb(self._value);
	      } catch (e) {
	        reject(deferred.promise, e);
	        return;
	      }
	      resolve(deferred.promise, ret);
	    });
	  }
	
	  function resolve(self, newValue) {
	    try {
	      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
	      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	        var then = newValue.then;
	        if (newValue instanceof Promise) {
	          self._state = 3;
	          self._value = newValue;
	          finale(self);
	          return;
	        } else if (typeof then === 'function') {
	          doResolve(bind(then, newValue), self);
	          return;
	        }
	      }
	      self._state = 1;
	      self._value = newValue;
	      finale(self);
	    } catch (e) {
	      reject(self, e);
	    }
	  }
	
	  function reject(self, newValue) {
	    self._state = 2;
	    self._value = newValue;
	    finale(self);
	  }
	
	  function finale(self) {
	    if (self._state === 2 && self._deferreds.length === 0) {
	      Promise._immediateFn(function() {
	        if (!self._handled) {
	          Promise._unhandledRejectionFn(self._value);
	        }
	      });
	    }
	
	    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	      handle(self, self._deferreds[i]);
	    }
	    self._deferreds = null;
	  }
	
	  function Handler(onFulfilled, onRejected, promise) {
	    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	    this.promise = promise;
	  }
	
	  /**
	   * Take a potentially misbehaving resolver function and make sure
	   * onFulfilled and onRejected are only called once.
	   *
	   * Makes no guarantees about asynchrony.
	   */
	  function doResolve(fn, self) {
	    var done = false;
	    try {
	      fn(function (value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      }, function (reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      });
	    } catch (ex) {
	      if (done) return;
	      done = true;
	      reject(self, ex);
	    }
	  }
	
	  Promise.prototype['catch'] = function (onRejected) {
	    return this.then(null, onRejected);
	  };
	
	  Promise.prototype.then = function (onFulfilled, onRejected) {
	    var prom = new (this.constructor)(noop);
	
	    handle(this, new Handler(onFulfilled, onRejected, prom));
	    return prom;
	  };
	
	  Promise.all = function (arr) {
	    return new Promise(function (resolve, reject) {
	      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
	      var args = Array.prototype.slice.call(arr);
	      if (args.length === 0) return resolve([]);
	      var remaining = args.length;
	
	      function res(i, val) {
	        try {
	          if (val && (typeof val === 'object' || typeof val === 'function')) {
	            var then = val.then;
	            if (typeof then === 'function') {
	              then.call(val, function (val) {
	                res(i, val);
	              }, reject);
	              return;
	            }
	          }
	          args[i] = val;
	          if (--remaining === 0) {
	            resolve(args);
	          }
	        } catch (ex) {
	          reject(ex);
	        }
	      }
	
	      for (var i = 0; i < args.length; i++) {
	        res(i, args[i]);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    if (value && typeof value === 'object' && value.constructor === Promise) {
	      return value;
	    }
	
	    return new Promise(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (value) {
	    return new Promise(function (resolve, reject) {
	      reject(value);
	    });
	  };
	
	  Promise.race = function (values) {
	    return new Promise(function (resolve, reject) {
	      for (var i = 0, len = values.length; i < len; i++) {
	        values[i].then(resolve, reject);
	      }
	    });
	  };
	
	  // Use polyfill for setImmediate for performance gains
	  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
	    function (fn) {
	      setTimeoutFunc(fn, 0);
	    };
	
	  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	    if (typeof console !== 'undefined' && console) {
	      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	    }
	  };
	
	  /**
	   * Set the immediate function to execute callbacks
	   * @param fn {function} Function to execute
	   * @deprecated
	   */
	  Promise._setImmediateFn = function _setImmediateFn(fn) {
	    Promise._immediateFn = fn;
	  };
	
	  /**
	   * Change the function to execute on unhandled rejection
	   * @param {function} fn Function to execute on unhandled rejection
	   * @deprecated
	   */
	  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	    Promise._unhandledRejectionFn = fn;
	  };
	  
	  if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Promise;
	  } else if (!root.Promise) {
	    root.Promise = Promise;
	  }
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9).setImmediate))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(10);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(11)))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(13);
	
	__webpack_require__(334);
	
	__webpack_require__(335);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(67);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(74);
	__webpack_require__(75);
	__webpack_require__(76);
	__webpack_require__(77);
	__webpack_require__(78);
	__webpack_require__(80);
	__webpack_require__(82);
	__webpack_require__(84);
	__webpack_require__(86);
	__webpack_require__(89);
	__webpack_require__(90);
	__webpack_require__(91);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(99);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(105);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(123);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(128);
	__webpack_require__(129);
	__webpack_require__(130);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(134);
	__webpack_require__(135);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(163);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(166);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(205);
	__webpack_require__(207);
	__webpack_require__(209);
	__webpack_require__(210);
	__webpack_require__(211);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(226);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(329);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	module.exports = __webpack_require__(20);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(15);
	var has = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(17);
	var $export = __webpack_require__(19);
	var redefine = __webpack_require__(29);
	var META = __webpack_require__(33).KEY;
	var $fails = __webpack_require__(18);
	var shared = __webpack_require__(34);
	var setToStringTag = __webpack_require__(35);
	var uid = __webpack_require__(30);
	var wks = __webpack_require__(36);
	var wksExt = __webpack_require__(37);
	var wksDefine = __webpack_require__(38);
	var enumKeys = __webpack_require__(40);
	var isArray = __webpack_require__(55);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(24);
	var toIObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(27);
	var createDesc = __webpack_require__(28);
	var _create = __webpack_require__(56);
	var gOPNExt = __webpack_require__(59);
	var $GOPD = __webpack_require__(61);
	var $DP = __webpack_require__(22);
	var $keys = __webpack_require__(41);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(60).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(54).f = $propertyIsEnumerable;
	  __webpack_require__(53).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(39)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(18)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(20);
	var hide = __webpack_require__(21);
	var redefine = __webpack_require__(29);
	var ctx = __webpack_require__(31);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var createDesc = __webpack_require__(28);
	module.exports = __webpack_require__(17) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(23);
	var IE8_DOM_DEFINE = __webpack_require__(25);
	var toPrimitive = __webpack_require__(27);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(17) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(17) && !__webpack_require__(18)(function () {
	  return Object.defineProperty(__webpack_require__(26)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var document = __webpack_require__(15).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(24);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(21);
	var has = __webpack_require__(16);
	var SRC = __webpack_require__(30)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(20).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(32);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(30)('meta');
	var isObject = __webpack_require__(24);
	var has = __webpack_require__(16);
	var setDesc = __webpack_require__(22).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(18)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(22).f;
	var has = __webpack_require__(16);
	var TAG = __webpack_require__(36)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(34)('wks');
	var uid = __webpack_require__(30);
	var Symbol = __webpack_require__(15).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(36);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var core = __webpack_require__(20);
	var LIBRARY = __webpack_require__(39);
	var wksExt = __webpack_require__(37);
	var defineProperty = __webpack_require__(22).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(41);
	var gOPS = __webpack_require__(53);
	var pIE = __webpack_require__(54);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(42);
	var enumBugKeys = __webpack_require__(52);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(16);
	var toIObject = __webpack_require__(43);
	var arrayIndexOf = __webpack_require__(47)(false);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(44);
	var defined = __webpack_require__(46);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(45);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(43);
	var toLength = __webpack_require__(48);
	var toAbsoluteIndex = __webpack_require__(50);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(49);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(49);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(34)('keys');
	var uid = __webpack_require__(30);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(45);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(23);
	var dPs = __webpack_require__(57);
	var enumBugKeys = __webpack_require__(52);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(26)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(58).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var anObject = __webpack_require__(23);
	var getKeys = __webpack_require__(41);
	
	module.exports = __webpack_require__(17) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(15).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(43);
	var gOPN = __webpack_require__(60).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(42);
	var hiddenKeys = __webpack_require__(52).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(54);
	var createDesc = __webpack_require__(28);
	var toIObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(27);
	var has = __webpack_require__(16);
	var IE8_DOM_DEFINE = __webpack_require__(25);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(17) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(56) });


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperty: __webpack_require__(22).f });


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperties: __webpack_require__(57) });


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(43);
	var $getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	__webpack_require__(66)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(19);
	var core = __webpack_require__(20);
	var fails = __webpack_require__(18);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(68);
	var $getPrototypeOf = __webpack_require__(69);
	
	__webpack_require__(66)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(46);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(16);
	var toObject = __webpack_require__(68);
	var IE_PROTO = __webpack_require__(51)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(68);
	var $keys = __webpack_require__(41);
	
	__webpack_require__(66)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(66)('getOwnPropertyNames', function () {
	  return __webpack_require__(59).f;
	});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(66)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(66)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(24);
	var meta = __webpack_require__(33).onFreeze;
	
	__webpack_require__(66)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(66)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(66)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(24);
	
	__webpack_require__(66)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(19);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(79) });


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(41);
	var gOPS = __webpack_require__(53);
	var pIE = __webpack_require__(54);
	var toObject = __webpack_require__(68);
	var IObject = __webpack_require__(44);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(18)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(19);
	$export($export.S, 'Object', { is: __webpack_require__(81) });


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(19);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(83).set });


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(24);
	var anObject = __webpack_require__(23);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(31)(Function.call, __webpack_require__(61).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(85);
	var test = {};
	test[__webpack_require__(36)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(29)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(45);
	var TAG = __webpack_require__(36)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(19);
	
	$export($export.P, 'Function', { bind: __webpack_require__(87) });


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(32);
	var isObject = __webpack_require__(24);
	var invoke = __webpack_require__(88);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(17) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(24);
	var getPrototypeOf = __webpack_require__(69);
	var HAS_INSTANCE = __webpack_require__(36)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(22).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var $parseInt = __webpack_require__(92);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(15).parseInt;
	var $trim = __webpack_require__(93).trim;
	var ws = __webpack_require__(94);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var defined = __webpack_require__(46);
	var fails = __webpack_require__(18);
	var spaces = __webpack_require__(94);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var $parseFloat = __webpack_require__(96);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(15).parseFloat;
	var $trim = __webpack_require__(93).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(94) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var has = __webpack_require__(16);
	var cof = __webpack_require__(45);
	var inheritIfRequired = __webpack_require__(98);
	var toPrimitive = __webpack_require__(27);
	var fails = __webpack_require__(18);
	var gOPN = __webpack_require__(60).f;
	var gOPD = __webpack_require__(61).f;
	var dP = __webpack_require__(22).f;
	var $trim = __webpack_require__(93).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(56)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(17) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(29)(global, NUMBER, $Number);
	}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var setPrototypeOf = __webpack_require__(83).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toInteger = __webpack_require__(49);
	var aNumberValue = __webpack_require__(100);
	var repeat = __webpack_require__(101);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(18)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(45);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(49);
	var defined = __webpack_require__(46);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $fails = __webpack_require__(18);
	var aNumberValue = __webpack_require__(100);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(19);
	var _isFinite = __webpack_require__(15).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(106) });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(24);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(19);
	var isInteger = __webpack_require__(106);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var $parseFloat = __webpack_require__(96);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var $parseInt = __webpack_require__(92);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(19);
	var log1p = __webpack_require__(114);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(19);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(19);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(19);
	var sign = __webpack_require__(118);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(19);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(19);
	var $expm1 = __webpack_require__(122);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { fround: __webpack_require__(124) });


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(118);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(19);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(19);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(114) });


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { sign: __webpack_require__(118) });


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(19);
	var expm1 = __webpack_require__(122);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(19);
	var expm1 = __webpack_require__(122);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var toAbsoluteIndex = __webpack_require__(50);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var toIObject = __webpack_require__(43);
	var toLength = __webpack_require__(48);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(93)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(138)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(139)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(49);
	var defined = __webpack_require__(46);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(39);
	var $export = __webpack_require__(19);
	var redefine = __webpack_require__(29);
	var hide = __webpack_require__(21);
	var has = __webpack_require__(16);
	var Iterators = __webpack_require__(140);
	var $iterCreate = __webpack_require__(141);
	var setToStringTag = __webpack_require__(35);
	var getPrototypeOf = __webpack_require__(69);
	var ITERATOR = __webpack_require__(36)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(56);
	var descriptor = __webpack_require__(28);
	var setToStringTag = __webpack_require__(35);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(21)(IteratorPrototype, __webpack_require__(36)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $at = __webpack_require__(138)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(19);
	var toLength = __webpack_require__(48);
	var context = __webpack_require__(144);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(146)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(145);
	var defined = __webpack_require__(46);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(24);
	var cof = __webpack_require__(45);
	var MATCH = __webpack_require__(36)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(36)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(19);
	var context = __webpack_require__(144);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(146)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(101)
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(19);
	var toLength = __webpack_require__(48);
	var context = __webpack_require__(144);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(146)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(151)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var fails = __webpack_require__(18);
	var defined = __webpack_require__(46);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(151)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(151)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(151)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(151)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(151)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(151)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(151)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(151)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(151)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(151)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(151)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(151)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var toPrimitive = __webpack_require__(27);
	
	$export($export.P + $export.F * __webpack_require__(18)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(19);
	var toISOString = __webpack_require__(167);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(18);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(29)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(36)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(21)(proto, TO_PRIMITIVE, __webpack_require__(170));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(27);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(55) });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(31);
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var call = __webpack_require__(173);
	var isArrayIter = __webpack_require__(174);
	var toLength = __webpack_require__(48);
	var createProperty = __webpack_require__(175);
	var getIterFn = __webpack_require__(176);
	
	$export($export.S + $export.F * !__webpack_require__(177)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(23);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(140);
	var ITERATOR = __webpack_require__(36)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(22);
	var createDesc = __webpack_require__(28);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(85);
	var ITERATOR = __webpack_require__(36)('iterator');
	var Iterators = __webpack_require__(140);
	module.exports = __webpack_require__(20).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(36)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var createProperty = __webpack_require__(175);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(19);
	var toIObject = __webpack_require__(43);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(44) != Object || !__webpack_require__(180)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(18);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var html = __webpack_require__(58);
	var cof = __webpack_require__(45);
	var toAbsoluteIndex = __webpack_require__(50);
	var toLength = __webpack_require__(48);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(18)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var aFunction = __webpack_require__(32);
	var toObject = __webpack_require__(68);
	var fails = __webpack_require__(18);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(180)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $forEach = __webpack_require__(184)(0);
	var STRICT = __webpack_require__(180)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(31);
	var IObject = __webpack_require__(44);
	var toObject = __webpack_require__(68);
	var toLength = __webpack_require__(48);
	var asc = __webpack_require__(185);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(186);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	var isArray = __webpack_require__(55);
	var SPECIES = __webpack_require__(36)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $map = __webpack_require__(184)(1);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $filter = __webpack_require__(184)(2);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $some = __webpack_require__(184)(3);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $every = __webpack_require__(184)(4);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $reduce = __webpack_require__(192);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(32);
	var toObject = __webpack_require__(68);
	var IObject = __webpack_require__(44);
	var toLength = __webpack_require__(48);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $reduce = __webpack_require__(192);
	
	$export($export.P + $export.F * !__webpack_require__(180)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $indexOf = __webpack_require__(47)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(180)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toIObject = __webpack_require__(43);
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(48);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(180)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(19);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(197) });
	
	__webpack_require__(198)('copyWithin');


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(68);
	var toAbsoluteIndex = __webpack_require__(50);
	var toLength = __webpack_require__(48);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(36)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(21)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(19);
	
	$export($export.P, 'Array', { fill: __webpack_require__(200) });
	
	__webpack_require__(198)('fill');


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(68);
	var toAbsoluteIndex = __webpack_require__(50);
	var toLength = __webpack_require__(48);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(19);
	var $find = __webpack_require__(184)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(198)(KEY);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(19);
	var $find = __webpack_require__(184)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(198)(KEY);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(204)('Array');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var dP = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(17);
	var SPECIES = __webpack_require__(36)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(198);
	var step = __webpack_require__(206);
	var Iterators = __webpack_require__(140);
	var toIObject = __webpack_require__(43);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(139)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var inheritIfRequired = __webpack_require__(98);
	var dP = __webpack_require__(22).f;
	var gOPN = __webpack_require__(60).f;
	var isRegExp = __webpack_require__(145);
	var $flags = __webpack_require__(208);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(17) && (!CORRECT_NEW || __webpack_require__(18)(function () {
	  re2[__webpack_require__(36)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(29)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(204)('RegExp');


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(23);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(210);
	var anObject = __webpack_require__(23);
	var $flags = __webpack_require__(208);
	var DESCRIPTORS = __webpack_require__(17);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(29)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(17) && /./g.flags != 'g') __webpack_require__(22).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(208)
	});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(212)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(21);
	var redefine = __webpack_require__(29);
	var fails = __webpack_require__(18);
	var defined = __webpack_require__(46);
	var wks = __webpack_require__(36);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(212)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(212)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(212)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(145);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(39);
	var global = __webpack_require__(15);
	var ctx = __webpack_require__(31);
	var classof = __webpack_require__(85);
	var $export = __webpack_require__(19);
	var isObject = __webpack_require__(24);
	var aFunction = __webpack_require__(32);
	var anInstance = __webpack_require__(217);
	var forOf = __webpack_require__(218);
	var speciesConstructor = __webpack_require__(219);
	var task = __webpack_require__(220).set;
	var microtask = __webpack_require__(221)();
	var newPromiseCapabilityModule = __webpack_require__(222);
	var perform = __webpack_require__(223);
	var promiseResolve = __webpack_require__(224);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(36)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(225)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(35)($Promise, PROMISE);
	__webpack_require__(204)(PROMISE);
	Wrapper = __webpack_require__(20)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(177)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(31);
	var call = __webpack_require__(173);
	var isArrayIter = __webpack_require__(174);
	var anObject = __webpack_require__(23);
	var toLength = __webpack_require__(48);
	var getIterFn = __webpack_require__(176);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(23);
	var aFunction = __webpack_require__(32);
	var SPECIES = __webpack_require__(36)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(31);
	var invoke = __webpack_require__(88);
	var html = __webpack_require__(58);
	var cel = __webpack_require__(26);
	var global = __webpack_require__(15);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(45)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var macrotask = __webpack_require__(220).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(45)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(32);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(24);
	var newPromiseCapability = __webpack_require__(222);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(29);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(227);
	var validate = __webpack_require__(228);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(229)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(22).f;
	var create = __webpack_require__(56);
	var redefineAll = __webpack_require__(225);
	var ctx = __webpack_require__(31);
	var anInstance = __webpack_require__(217);
	var forOf = __webpack_require__(218);
	var $iterDefine = __webpack_require__(139);
	var step = __webpack_require__(206);
	var setSpecies = __webpack_require__(204);
	var DESCRIPTORS = __webpack_require__(17);
	var fastKey = __webpack_require__(33).fastKey;
	var validate = __webpack_require__(228);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(24);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var $export = __webpack_require__(19);
	var redefine = __webpack_require__(29);
	var redefineAll = __webpack_require__(225);
	var meta = __webpack_require__(33);
	var forOf = __webpack_require__(218);
	var anInstance = __webpack_require__(217);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(18);
	var $iterDetect = __webpack_require__(177);
	var setToStringTag = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(98);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(227);
	var validate = __webpack_require__(228);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(229)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(184)(0);
	var redefine = __webpack_require__(29);
	var meta = __webpack_require__(33);
	var assign = __webpack_require__(79);
	var weak = __webpack_require__(232);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(18);
	var validate = __webpack_require__(228);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(229)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(225);
	var getWeak = __webpack_require__(33).getWeak;
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(24);
	var anInstance = __webpack_require__(217);
	var forOf = __webpack_require__(218);
	var createArrayMethod = __webpack_require__(184);
	var $has = __webpack_require__(16);
	var validate = __webpack_require__(228);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(232);
	var validate = __webpack_require__(228);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(229)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var $typed = __webpack_require__(235);
	var buffer = __webpack_require__(236);
	var anObject = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(50);
	var toLength = __webpack_require__(48);
	var isObject = __webpack_require__(24);
	var ArrayBuffer = __webpack_require__(15).ArrayBuffer;
	var speciesConstructor = __webpack_require__(219);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(204)(ARRAY_BUFFER);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var hide = __webpack_require__(21);
	var uid = __webpack_require__(30);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(15);
	var DESCRIPTORS = __webpack_require__(17);
	var LIBRARY = __webpack_require__(39);
	var $typed = __webpack_require__(235);
	var hide = __webpack_require__(21);
	var redefineAll = __webpack_require__(225);
	var fails = __webpack_require__(18);
	var anInstance = __webpack_require__(217);
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(48);
	var toIndex = __webpack_require__(237);
	var gOPN = __webpack_require__(60).f;
	var dP = __webpack_require__(22).f;
	var arrayFill = __webpack_require__(200);
	var setToStringTag = __webpack_require__(35);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(49);
	var toLength = __webpack_require__(48);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	$export($export.G + $export.W + $export.F * !__webpack_require__(235).ABV, {
	  DataView: __webpack_require__(236).DataView
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(17)) {
	  var LIBRARY = __webpack_require__(39);
	  var global = __webpack_require__(15);
	  var fails = __webpack_require__(18);
	  var $export = __webpack_require__(19);
	  var $typed = __webpack_require__(235);
	  var $buffer = __webpack_require__(236);
	  var ctx = __webpack_require__(31);
	  var anInstance = __webpack_require__(217);
	  var propertyDesc = __webpack_require__(28);
	  var hide = __webpack_require__(21);
	  var redefineAll = __webpack_require__(225);
	  var toInteger = __webpack_require__(49);
	  var toLength = __webpack_require__(48);
	  var toIndex = __webpack_require__(237);
	  var toAbsoluteIndex = __webpack_require__(50);
	  var toPrimitive = __webpack_require__(27);
	  var has = __webpack_require__(16);
	  var classof = __webpack_require__(85);
	  var isObject = __webpack_require__(24);
	  var toObject = __webpack_require__(68);
	  var isArrayIter = __webpack_require__(174);
	  var create = __webpack_require__(56);
	  var getPrototypeOf = __webpack_require__(69);
	  var gOPN = __webpack_require__(60).f;
	  var getIterFn = __webpack_require__(176);
	  var uid = __webpack_require__(30);
	  var wks = __webpack_require__(36);
	  var createArrayMethod = __webpack_require__(184);
	  var createArrayIncludes = __webpack_require__(47);
	  var speciesConstructor = __webpack_require__(219);
	  var ArrayIterators = __webpack_require__(205);
	  var Iterators = __webpack_require__(140);
	  var $iterDetect = __webpack_require__(177);
	  var setSpecies = __webpack_require__(204);
	  var arrayFill = __webpack_require__(200);
	  var arrayCopyWithin = __webpack_require__(197);
	  var $DP = __webpack_require__(22);
	  var $GOPD = __webpack_require__(61);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(240)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(19);
	var aFunction = __webpack_require__(32);
	var anObject = __webpack_require__(23);
	var rApply = (__webpack_require__(15).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(18)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(19);
	var create = __webpack_require__(56);
	var aFunction = __webpack_require__(32);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(24);
	var fails = __webpack_require__(18);
	var bind = __webpack_require__(87);
	var rConstruct = (__webpack_require__(15).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(22);
	var $export = __webpack_require__(19);
	var anObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(27);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(18)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(19);
	var gOPD = __webpack_require__(61).f;
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(19);
	var anObject = __webpack_require__(23);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(141)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(69);
	var has = __webpack_require__(16);
	var $export = __webpack_require__(19);
	var isObject = __webpack_require__(24);
	var anObject = __webpack_require__(23);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(61);
	var $export = __webpack_require__(19);
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(19);
	var getProto = __webpack_require__(69);
	var anObject = __webpack_require__(23);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(19);
	var anObject = __webpack_require__(23);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(260) });


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(60);
	var gOPS = __webpack_require__(53);
	var anObject = __webpack_require__(23);
	var Reflect = __webpack_require__(15).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(19);
	var anObject = __webpack_require__(23);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(22);
	var gOPD = __webpack_require__(61);
	var getPrototypeOf = __webpack_require__(69);
	var has = __webpack_require__(16);
	var $export = __webpack_require__(19);
	var createDesc = __webpack_require__(28);
	var anObject = __webpack_require__(23);
	var isObject = __webpack_require__(24);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(19);
	var setProto = __webpack_require__(83);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(19);
	var $includes = __webpack_require__(47)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(198)('includes');


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(19);
	var flattenIntoArray = __webpack_require__(266);
	var toObject = __webpack_require__(68);
	var toLength = __webpack_require__(48);
	var aFunction = __webpack_require__(32);
	var arraySpeciesCreate = __webpack_require__(185);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(198)('flatMap');


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(55);
	var isObject = __webpack_require__(24);
	var toLength = __webpack_require__(48);
	var ctx = __webpack_require__(31);
	var IS_CONCAT_SPREADABLE = __webpack_require__(36)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(19);
	var flattenIntoArray = __webpack_require__(266);
	var toObject = __webpack_require__(68);
	var toLength = __webpack_require__(48);
	var toInteger = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(185);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(198)('flatten');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(19);
	var $at = __webpack_require__(138)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(19);
	var $pad = __webpack_require__(270);
	var userAgent = __webpack_require__(271);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(48);
	var repeat = __webpack_require__(101);
	var defined = __webpack_require__(46);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(15);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(19);
	var $pad = __webpack_require__(270);
	var userAgent = __webpack_require__(271);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(93)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(93)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(19);
	var defined = __webpack_require__(46);
	var toLength = __webpack_require__(48);
	var isRegExp = __webpack_require__(145);
	var getFlags = __webpack_require__(208);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(141)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(38)('asyncIterator');


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(38)('observable');


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(19);
	var ownKeys = __webpack_require__(260);
	var toIObject = __webpack_require__(43);
	var gOPD = __webpack_require__(61);
	var createProperty = __webpack_require__(175);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(19);
	var $values = __webpack_require__(280)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(41);
	var toIObject = __webpack_require__(43);
	var isEnum = __webpack_require__(54).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(19);
	var $entries = __webpack_require__(280)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var aFunction = __webpack_require__(32);
	var $defineProperty = __webpack_require__(22);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(283), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(39) || !__webpack_require__(18)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(15)[K];
	});


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var aFunction = __webpack_require__(32);
	var $defineProperty = __webpack_require__(22);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(283), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var toPrimitive = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(69);
	var getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(283), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(19);
	var toObject = __webpack_require__(68);
	var toPrimitive = __webpack_require__(27);
	var getPrototypeOf = __webpack_require__(69);
	var getOwnPropertyDescriptor = __webpack_require__(61).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(283), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(19);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(288)('Map') });


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(85);
	var from = __webpack_require__(289);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(218);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(19);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(288)('Set') });


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(292)('Map');


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(19);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(292)('Set');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(292)('WeakMap');


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(292)('WeakSet');


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(297)('Map');


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(19);
	var aFunction = __webpack_require__(32);
	var ctx = __webpack_require__(31);
	var forOf = __webpack_require__(218);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(297)('Set');


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(297)('WeakMap');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(297)('WeakSet');


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(19);
	
	$export($export.G, { global: __webpack_require__(15) });


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(19);
	
	$export($export.S, 'System', { global: __webpack_require__(15) });


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(19);
	var cof = __webpack_require__(45);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	var scale = __webpack_require__(308);
	var fround = __webpack_require__(124);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { scale: __webpack_require__(308) });


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(19);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(19);
	var core = __webpack_require__(20);
	var global = __webpack_require__(15);
	var speciesConstructor = __webpack_require__(219);
	var promiseResolve = __webpack_require__(224);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(19);
	var newPromiseCapability = __webpack_require__(222);
	var perform = __webpack_require__(223);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(226);
	var $export = __webpack_require__(19);
	var shared = __webpack_require__(34)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(231))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(230);
	var from = __webpack_require__(289);
	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var getPrototypeOf = __webpack_require__(69);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(320);
	var anObject = __webpack_require__(23);
	var aFunction = __webpack_require__(32);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(19);
	var microtask = __webpack_require__(221)();
	var process = __webpack_require__(15).process;
	var isNode = __webpack_require__(45)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(19);
	var global = __webpack_require__(15);
	var core = __webpack_require__(20);
	var microtask = __webpack_require__(221)();
	var OBSERVABLE = __webpack_require__(36)('observable');
	var aFunction = __webpack_require__(32);
	var anObject = __webpack_require__(23);
	var anInstance = __webpack_require__(217);
	var redefineAll = __webpack_require__(225);
	var hide = __webpack_require__(21);
	var forOf = __webpack_require__(218);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(204)('Observable');


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(15);
	var $export = __webpack_require__(19);
	var userAgent = __webpack_require__(271);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(19);
	var $task = __webpack_require__(220);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(205);
	var getKeys = __webpack_require__(41);
	var redefine = __webpack_require__(29);
	var global = __webpack_require__(15);
	var hide = __webpack_require__(21);
	var Iterators = __webpack_require__(140);
	var wks = __webpack_require__(36);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(336);
	module.exports = __webpack_require__(20).RegExp.escape;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(19);
	var $re = __webpack_require__(337)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrowserWarning = function BrowserWarning(options) {
	  (0, _classCallCheck3.default)(this, BrowserWarning);
	
	  this.element = options.element;
	
	  // Add class if IE10 or lower
	  if (document.documentMode <= 10) {
	    document.documentElement.className += ' old-ie';
	  }
	};
	
	exports.default = BrowserWarning;

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _smoothScroll = __webpack_require__(4);
	
	var _smoothScroll2 = _interopRequireDefault(_smoothScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section that can be scrolled to via URL hash.
	 * @author Dayne Coulson-Hoffacker
	 */
	var Section =
	/**
	 * Constructs a new section.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 * @param {Hurdler} options.hurdler - Hurdler instance.
	 */
	function Section(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, Section);
	
	  if (!window.smoothScroll) {
	    window.smoothScroll = new _smoothScroll2.default();
	  }
	  this.element = options.element;
	  this.hurdler = options.hurdler;
	  this.showMyBonus = document.getElementById('show-my-bonus');
	  this.calculatorSection = document.getElementById('calculate-my-bonus');
	  this.termsAndConditions = document.getElementById('terms-and-conditions');
	  this.standardScrollOptions = {
	    speed: 1000,
	    easing: 'easeOutQuart',
	    after: function after(element) {
	      if (element.id == 'calculate-my-bonus') {
	        document.body.classList.remove('locked');
	        _this.calculatorSection.classList.add('active');
	      }
	    }
	  };
	  this.termsAndConditionScrollOptions = {
	    speed: 1000,
	    easing: 'easeOutQuart',
	    offset: 140
	    // Enable URL hash access via Hurdler
	  };this.hurdler.addHurdle({
	    test: function test(element) {
	      return element.tagName === 'SECTION';
	    },
	    onJump: function onJump(element) {
	      if (_this.calculatorSection) {
	        document.getElementById('calculate-my-bonus').style.display = 'block';
	        window.smoothScroll.animateScroll(element, element, _this.standardScrollOptions);
	      } else if (_this.termsAndConditions) {
	        window.smoothScroll.animateScroll(element, element, _this.termsAndConditionScrollOptions);
	      }
	    }
	  });
	};
	
	exports.default = Section;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(342);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Globa header.
	 * @author Dayne Coulson-Hoffacker
	 */
	var GlobalHeader = function () {
	  /**
	   * Constructs a new global header component.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function GlobalHeader(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, GlobalHeader);
	
	    this.element = options.element;
	    this.hurdler = options.hurdler;
	    this.navItems = this.element.queryAll('li');
	
	    this.navItems.forEach(function (element) {
	      element.addEventListener('click', function (e) {
	        var index = _this.navItems.indexOf(element);
	        _this.reset(_this.navItems);
	        _this.activate(element, index);
	      });
	    });
	  }
	
	  (0, _createClass3.default)(GlobalHeader, [{
	    key: 'reset',
	    value: function reset() {
	      this.navItems.forEach(function (element) {
	        element.classList.remove('active');
	      });
	    }
	  }, {
	    key: 'activate',
	    value: function activate(element, index) {
	      element.classList.add('active');
	    }
	  }]);
	  return GlobalHeader;
	}();
	
	exports.default = GlobalHeader;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(343);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(344), __esModule: true };

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(345);
	var $Object = __webpack_require__(348).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(346);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(356), 'Object', { defineProperty: __webpack_require__(352).f });


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(347);
	var core = __webpack_require__(348);
	var ctx = __webpack_require__(349);
	var hide = __webpack_require__(351);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(350);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(352);
	var createDesc = __webpack_require__(360);
	module.exports = __webpack_require__(356) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(353);
	var IE8_DOM_DEFINE = __webpack_require__(355);
	var toPrimitive = __webpack_require__(359);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(356) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(354);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(356) && !__webpack_require__(357)(function () {
	  return Object.defineProperty(__webpack_require__(358)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(357)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(354);
	var document = __webpack_require__(347).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(354);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Accordion dropdown component.
	 * @author Dayne Coulson-Hoffacker
	 */
	var AccordionDropdown =
	/**
	 * Constructs a new counter component.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function AccordionDropdown(options) {
	  (0, _classCallCheck3.default)(this, AccordionDropdown);
	
	  this.element = options.element;
	  new Accordion(this.element);
	};
	
	exports.default = AccordionDropdown;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormOverlay = function FormOverlay(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, FormOverlay);
	
	  this.element = options.element;
	  this.closeButton = this.element.querySelector('.close');
	  this.remindMeLaterButton = document.querySelector('.remind-me-later span');
	
	  this.closeButton.addEventListener('click', function () {
	    _this.element.classList.remove('visible');
	    document.body.classList.remove('locked');
	    _this.remindMeLaterButton.classList.remove('hidden');
	  });
	};
	
	exports.default = FormOverlay;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(342);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Choice terms.
	 * @author Dayne Coulson-Hoffacker
	 */
	var ChoiceTerms = function () {
	  /**
	   * Constructs a new global header component.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function ChoiceTerms(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ChoiceTerms);
	
	    this.element = options.element;
	    this.choiceTerms = document.querySelector('[data-component="choice-terms"]');
	    this.choiceTerm = this.choiceTerms.queryAll('.choice-terms');
	    this.resultChoices = document.querySelector('.choices');
	    this.resultChoice = this.resultChoices.queryAll('.choice');
	
	    this.resultChoice.forEach(function (element) {
	      var infoButton = element.querySelector('.terms-and-conditions-icon');
	      var index = _this.resultChoice.indexOf(element);
	      infoButton.addEventListener('click', function (e) {
	        _this.activate(element, index);
	      });
	    });
	
	    this.choiceTerm.forEach(function (element) {
	      var closeButton = element.querySelector('.close');
	      closeButton.addEventListener('click', function (element) {
	        _this.reset();
	      });
	    });
	  }
	
	  (0, _createClass3.default)(ChoiceTerms, [{
	    key: 'reset',
	    value: function reset() {
	      this.resultChoice.forEach(function (element) {
	        element.classList.remove('active');
	      });
	      this.choiceTerm.forEach(function (element) {
	        element.classList.remove('active');
	      });
	    }
	  }, {
	    key: 'activate',
	    value: function activate(element, index) {
	      element.classList.add('active');
	      this.choiceTerm[index].classList.add('active');
	    }
	  }]);
	  return ChoiceTerms;
	}();
	
	exports.default = ChoiceTerms;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(342);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cards = __webpack_require__(365);
	
	var _cards2 = _interopRequireDefault(_cards);
	
	var _rewards = __webpack_require__(366);
	
	var _rewards2 = _interopRequireDefault(_rewards);
	
	var _leftPad = __webpack_require__(367);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calculator javascript.
	 * @author Dayne Coulson-Hoffacker
	 */
	var CalculateMyBonus = function () {
	  /**
	   * Constructs a new counter component.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function CalculateMyBonus(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, CalculateMyBonus);
	
	    this.element = options.element;
	    this.questions = this.element.queryAll('.single-question');
	    this.firstPart = this.element.querySelector('.first-part');
	    this.secondPart = this.element.querySelector('.second-part');
	    this.firstPartSelect = this.firstPart.querySelector('select');
	    this.secondPartSelect = this.secondPart.querySelector('select');
	    this.firstPartEmptySpan = this.firstPart.querySelector('.empty');
	    this.secondPartEmptySpan = this.secondPart.querySelector('.empty');
	    this.question1 = this.element.querySelector('#question-1');
	    this.question2 = this.element.querySelector('#question-2');
	    this.formWrapper = this.element.querySelector('.form-wrapper');
	    this.formInner = this.formWrapper.querySelector('.form-inner');
	    this.calculateSubmitWrapper = this.element.querySelector('.calculator-submit');
	    this.calculateSubmitBtn = this.calculateSubmitWrapper.querySelector('input[type="submit"]');
	    this.humorousLine = this.element.querySelector('.humorous-line');
	    this.plane = this.element.querySelector('.plane');
	    this.sectionHeader = this.element.querySelector('header');
	    this.redemption = document.querySelector('[data-component="redemption"]');
	
	    // Question 1 (First Part) Select Functionality
	    this.firstPartSelect.addEventListener('change', function () {
	      _this.element.classList.add('active');
	      var valueLength = 20;
	      var value = _this.firstPartSelect.value;
	      _this.selectedBank = value;
	      document.getElementById('summary-bank').innerHTML = value;
	      var truncatedValue = value.substring(0, valueLength);
	      _this.createCookie('BankName', value, 0);
	      if (value.length >= 20) {
	        _this.firstPartEmptySpan.innerHTML = truncatedValue + '...';
	      } else {
	        _this.firstPartEmptySpan.innerHTML = truncatedValue;
	      }
	
	      _this.secondPart.classList.add('active');
	      _this.populateCards();
	      _this.populateCities();
	    });
	
	    // Question 1 (Second Part) Select Functionality
	    this.secondPartSelect.addEventListener('change', function () {
	      var valueLength = 23;
	      var value = _this.secondPartSelect.value;
	      _this.selectedCard = value;
	      document.getElementById('summary-card').innerHTML = value;
	      var bankResult = void 0;
	      _cards2.default.forEach(function (bank) {
	        if (bank.bank === _this.selectedBank) bankResult = bank;
	      });
	      var cardResult = void 0;
	      bankResult.cards.forEach(function (card) {
	        if (card.name === _this.selectedCard) cardResult = card;
	      });
	      document.querySelector('.percentage-bonus').querySelector('.amount').innerHTML = cardResult.totalBonus;
	      document.querySelector('.extra-bonus').innerHTML = cardResult.bonusFinePrint;
	      var truncatedValue = value.substring(0, valueLength);
	      _this.createCookie('CardName', value, 0);
	      if (value.length >= 23) {
	        _this.secondPartEmptySpan.innerHTML = truncatedValue + '...';
	      } else {
	        _this.secondPartEmptySpan.innerHTML = truncatedValue;
	      }
	      document.getElementById('question-2').querySelector('.empty').innerHTML = '';
	      document.getElementById('points').selectedIndex = 0;
	      document.getElementById('question-3').querySelector('.empty').innerHTML = '';
	      document.getElementById('cities').selectedIndex = 0;
	      _this.question1.classList.add('is-complete');
	      _this.question1.classList.remove('active');
	      _this.question2.classList.add('active');
	      _this.formWrapper.classList.add('question-1-complete');
	      _this.sectionHeader.classList.add('hidden');
	      _this.populatePoints();
	    });
	
	    // Points to Cookie
	    this.element.querySelector('#points').addEventListener('change', function (event) {
	      _this.createCookie('Points', event.target.value, 0);
	      _this.selectedPoints = event.target.value;
	      document.getElementById('summary-points').innerHTML = event.target.value;
	      var b = void 0;
	      var c = void 0;
	      _cards2.default.forEach(function (bank) {
	        if (bank.bank === _this.selectedBank) b = bank;
	      });
	      b.cards.forEach(function (card) {
	        if (card.name === _this.selectedCard) c = card;
	      });
	      c.points.forEach(function (point) {
	        if (point.bankPoints === _this.selectedPoints) _this.velocityPoints = point.velocityPoints;
	      });
	    });
	
	    // City to Cookie
	    this.element.querySelector('#cities').addEventListener('change', function (event) {
	      _this.createCookie('City', event.target.value, 0);
	      _this.selectedPlace = event.target.value;
	    });
	
	    // Populate Banks
	    var bankSelect = this.element.querySelector('#bank');
	    _cards2.default.map(function (result) {
	      var bankSelectOption = _this.createNode('option');
	      bankSelectOption.value = '' + result.bank;
	      bankSelectOption.innerHTML = '' + result.bank;
	      _this.append(bankSelect, bankSelectOption);
	    });
	
	    // Functionality for on change of dropdowns
	    this.questions.forEach(function (element) {
	      var select = element.querySelector('select');
	      var emptySpan = element.querySelector('.empty');
	      var formWrapper = _this.element.querySelector('.form-wrapper');
	      select.addEventListener('change', function () {
	        emptySpan.innerHTML = select.value;
	        element.classList.add('is-complete');
	        element.classList.remove('active');
	        if (element.id == 'question-2') {
	          _this.formWrapper.classList.add('question-2-complete');
	          element.nextElementSibling.classList.add('active');
	          document.getElementById('question-3').querySelector('.empty').innerHTML = '';
	          document.getElementById('cities').selectedIndex = 0;
	        } else if (element.id == 'question-3') {
	          _this.formWrapper.classList.add('question-3-complete');
	          _this.calculateSubmitWrapper.classList.add('visible');
	        }
	      });
	    });
	
	    // Submit button Functionality
	    this.calculateSubmitBtn.addEventListener('click', function (event) {
	      event.preventDefault();
	      if (document.getElementById('bank').selectedIndex === 0 || document.getElementById('card').selectedIndex === 0 || document.getElementById('points').selectedIndex === 0 || document.getElementById('cities').selectedIndex === 0) {
	        if (!document.getElementById('form-error')) {
	          var error = _this.createNode('p');
	          error.id = 'form-error';
	          error.style.color = '#d6083b';
	          error.style.margin = '1em 0';
	          error.style.fontWeight = 800;
	          error.innerHTML = 'Please complete all fields';
	          document.querySelector('.calculator-submit').appendChild(error);
	        }
	      } else {
	        _this.formInner.classList.add('hidden');
	        _this.populateResults();
	        setTimeout(function () {
	          _this.formInner.style.display = 'none';
	        }, 100);
	        _this.humorousLine.classList.add('visible');
	        _this.plane.classList.add('full');
	        _this.plane.addEventListener('transitionend', function (event) {
	          _this.redemption.classList.add('visible');
	          document.body.classList.add('locked');
	        });
	      }
	    });
	  }
	
	  // Populate Results
	
	
	  (0, _createClass3.default)(CalculateMyBonus, [{
	    key: 'populateResults',
	    value: function populateResults() {
	      var _this2 = this;
	
	      var results = document.querySelector('.choices').queryAll('.choice');
	      var r = void 0;
	      _rewards2.default.forEach(function (reward) {
	        if (reward.velocityPoints === _this2.velocityPoints) r = reward.rewards;
	      });
	      var p = void 0;
	      r.forEach(function (place) {
	        if (place.originatingPlace === _this2.selectedPlace) p = place.displayOptions;
	      });
	      results.forEach(function (result, index) {
	        if (p[index].type === 'Flight') {
	          result.querySelector('img').src = '/content/dam/velocity/global/rewards_images/' + p[index].destination.replace(/\s/g, '') + '.png';
	          result.querySelector('img').alt = '' + p[index].destination.replace(/\s/g, '');
	        } else {
	          result.querySelector('img').src = '/content/dam/velocity/global/rewards_images/' + p[index].type.replace(/\s/g, '') + '.png';
	          result.querySelector('img').alt = '' + p[index].type.replace(/\s/g, '');
	        }
	
	        if (p[index].type === 'Flight' || p[index].type === 'Upgrade') {
	          if (p[index].quantity.includes('Over halfway')) {
	            result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + p[index].type;
	          } else {
	            if (p[index].quantity > 1) {
	              result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + 'x' + ' ' + p[index].type + 's';
	            } else {
	              result.querySelector('.offer').innerHTML = (p[index].quantity || '01') + ' ' + 'x' + ' ' + p[index].type;
	            }
	          }
	        } else {
	          var quantity = '';
	          if (p[index].quantity !== '') quantity = p[index].quantity;
	          result.querySelector('.offer').innerHTML = quantity + ' ' + 'x' + ' ' + p[index].type;
	        }
	
	        if (p[index].type === 'Flight') result.querySelector('.type-of-offer').innerHTML = 'From ' + p[index].origin + ' To ' + p[index].destination;else result.querySelector('.type-of-offer').innerHTML = p[index].class;
	
	        if (p[index].type === 'Upgrade') result.querySelector('.to-and-from').innerHTML = 'From ' + p[index].origin + ' To ' + p[index].destination;else result.querySelector('.to-and-from').innerHTML = p[index].class;
	
	        if (p[index].type === 'Fuel' || p[index].type === 'flight') {
	          result.querySelector('.to-and-from').innerHTML = '';
	        }
	
	        if (p[index].type === 'Fuel' && p[index].class === 'off') {
	          result.querySelector('.offer').innerHTML = p[index].quantity;
	          result.querySelector('.type-of-offer').innerHTML = p[index].type;
	          result.querySelector('.to-and-from').innerHTML = '';
	        }
	
	        if (p[index].type === 'Flight Discount' && p[index].class === 'A Virgin Australia Flight') {
	          result.querySelector('.offer').innerHTML = p[index].quantity;
	          result.querySelector('.to-and-from').innerHTML = '';
	        }
	
	        if (p[index].type === 'Lounge Pass' && p[index].class === 'Virgin Australia') {
	          result.querySelector('.offer').innerHTML = p[index].class;
	          result.querySelector('.type-of-offer').innerHTML = p[index].type;
	          result.querySelector('.to-and-from').innerHTML = '';
	        }
	
	        if (p[index].type === 'Gift Card') {
	          result.querySelector('.offer').innerHTML = p[index].quantity + '  ' + p[index].type;
	          result.querySelector('.type-of-offer').innerHTML = p[index].class;
	          result.querySelector('.to-and-from').innerHTML = '';
	        }
	
	        result.querySelector('.print').innerHTML = p[index].disclaimer.replace('[x]', p[index].airTaxes);
	
	        var choices = document.querySelector('#terms-choices').queryAll('.choice-terms');
	        choices.forEach(function (choice, i) {
	          choice.querySelector('.terms').innerHTML = p[i].shortTerms;
	        });
	      });
	    }
	
	    // Populate Cards
	
	  }, {
	    key: 'populateCards',
	    value: function populateCards() {
	      var _this3 = this;
	
	      document.getElementById('card').options.length = 1;
	      var result = void 0;
	      _cards2.default.forEach(function (bank) {
	        if (bank.bank === _this3.selectedBank) result = bank;
	      });
	      result.cards.map(function (result) {
	        var cardSelect = _this3.element.querySelector('#card');
	        var cardSelectOption = _this3.createNode('option');
	        cardSelectOption.value = '' + result.name;
	        cardSelectOption.innerHTML = '' + result.name;
	        _this3.append(cardSelect, cardSelectOption);
	      });
	      this.secondPartEmptySpan.innerHTML = '';
	      document.getElementById('card').selectedIndex = 0;
	      document.getElementById('question-2').querySelector('.empty').innerHTML = '';
	      document.getElementById('points').selectedIndex = 0;
	      document.getElementById('question-3').querySelector('.empty').innerHTML = '';
	      document.getElementById('cities').selectedIndex = 0;
	    }
	  }, {
	    key: 'populateCities',
	    value: function populateCities() {
	      var _this4 = this;
	
	      document.getElementById('cities').options.length = 1;
	      var b = void 0;
	      _cards2.default.forEach(function (bank) {
	        if (bank.bank === _this4.selectedBank) b = bank;
	      });
	      b.cities.map(function (result) {
	        var citySelect = _this4.element.querySelector('#cities');
	        var citySelectOption = _this4.createNode('option');
	        citySelectOption.value = '' + result;
	        citySelectOption.innerHTML = '' + result;
	        _this4.append(citySelect, citySelectOption);
	      });
	    }
	  }, {
	    key: 'populatePoints',
	    value: function populatePoints() {
	      var _this5 = this;
	
	      document.getElementById('points').options.length = 1;
	      var b = void 0;
	      var c = void 0;
	      _cards2.default.forEach(function (bank) {
	        if (bank.bank === _this5.selectedBank) b = bank;
	      });
	      b.cards.forEach(function (card) {
	        if (card.name === _this5.selectedCard) c = card;
	      });
	      c.points.map(function (result) {
	        var pointSelect = _this5.element.querySelector('#points');
	        var pointSelectOption = _this5.createNode('option');
	        pointSelectOption.value = '' + result.bankPoints;
	        pointSelectOption.innerHTML = '' + result.bankPoints;
	        _this5.append(pointSelect, pointSelectOption);
	      });
	      document.getElementById('minimum').innerHTML = 'Your card has a minimum transfer amount of ' + c.minimumPoints + ' points';
	      if (b.bank == 'Bank of Melbourne' || b.bank == 'BankSA' || b.bank == 'St George Bank' || b.bank == 'Westpac') {
	        document.getElementById('auto-redemption').style.display = 'block';
	      } else {
	        document.getElementById('auto-redemption').style.display = 'none';
	      }
	    }
	
	    // Create node function
	
	  }, {
	    key: 'createNode',
	    value: function createNode(element) {
	      return document.createElement(element);
	    }
	
	    // Append function
	
	  }, {
	    key: 'append',
	    value: function append(parent, el) {
	      return parent.appendChild(el);
	    }
	
	    // Create cookie function
	
	  }, {
	    key: 'createCookie',
	    value: function createCookie(name, value, days) {
	      var expires;
	      if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	        expires = "; expires=" + date.toGMTString();
	      } else {
	        expires = "";
	      }
	      document.cookie = name + "=" + value + expires + "; path=/";
	    }
	
	    // Read cookie
	
	  }, {
	    key: 'readCookie',
	    value: function readCookie(name) {
	      var nameEQ = name + "=";
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1, c.length);
	        }
	        if (c.indexOf(nameEQ) === 0) {
	          return c.substring(nameEQ.length, c.length);
	        }
	      }
	      return null;
	    }
	  }]);
	  return CalculateMyBonus;
	}();
	
	exports.default = CalculateMyBonus;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var banks = [{
		"bank": "American Express",
		"order": 1,
		"cards": [{
			"name": "Platinum Edge Credit Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Platinum Rewards Credit Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Platinum Reserve Credit Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Corporate Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Accelerator Credit Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Gold Card",
			"points": [{
				"bankPoints": "4,500-6,799",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,800-15,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "16,000-39,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "40,000-78,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "79,000-159,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "160,000-314,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">630,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Centurion Card",
			"points": [{
				"bankPoints": "4,000-6,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,500-14,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "15,000-35,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "36,000-71,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "72,000-144,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "145,000-289,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "290,000-579,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">580,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "25",
			"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
		}, {
			"name": "Rewards Advantage Card",
			"points": [{
				"bankPoints": "4,000-6,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,500-14,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "15,000-35,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "36,000-71,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "72,000-144,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "145,000-289,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "290,000-579,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">580,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "25",
			"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
		}, {
			"name": "Platinum Card",
			"points": [{
				"bankPoints": "4,000-6,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "6,500-14,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "15,000-35,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "36,000-71,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "72,000-144,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "145,000-289,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "290,000-579,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">580,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "25",
			"bonusFinePrint": "That's an extra 10% on top of the 15% Velocity Bonus"
		}, {
			"name": "David Jones American Express Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "David Jones Platinum American Express Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Card",
			"points": [{
				"bankPoints": "6600-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-58,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "59,000-117,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">940,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Gold Business Card",
			"points": [{
				"bankPoints": "6600-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-58,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "59,000-117,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">940,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Platinum Business Card",
			"points": [{
				"bankPoints": "6600-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-58,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "59,000-117,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">940,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Essential&trade; Credit Card",
			"points": [{
				"bankPoints": "5,800-8,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "9,000-20,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "21,000-52,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "53,000-104,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "105,000-209,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "210,000-419,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "420,000-834,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">835,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Gold Credit Card",
			"points": [{
				"bankPoints": "5,800-8,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "9,000-20,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "21,000-52,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "53,000-104,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "105,000-209,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "210,000-419,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "420,000-834,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">835,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Explorer&trade; Credit Card",
			"points": [{
				"bankPoints": "5,800-8,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "9,000-20,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "21,000-52,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "53,000-104,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "105,000-209,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "210,000-419,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "420,000-834,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">835,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	
	}, {
		"bank": "ANZ",
		"order": 2,
		"cards": [{
			"name": "Rewards Credit Card",
			"points": [{
				"bankPoints": "6,700-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-59,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "60,000-119,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "120,000-239,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "240,000-479,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "480,000-959,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">960,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}, {
			"name": "Rewards Platinum Credit Card",
			"points": [{
				"bankPoints": "6,700-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-59,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "60,000-119,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "120,000-239,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "240,000-479,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "480,000-959,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">960,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}, {
			"name": "Rewards Black Credit Card",
			"points": [{
				"bankPoints": "6,700-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-59,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "60,000-119,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "120,000-239,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "240,000-479,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "480,000-959,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">960,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}, {
			"name": "Rewards Travel Adventures Card",
			"points": [{
				"bankPoints": "6,700-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-59,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "60,000-119,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "120,000-239,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "240,000-479,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "480,000-959,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">960,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "ANZ Business",
		"order": 3,
		"cards": [{
			"name": "Business Rewards",
			"points": [{
				"bankPoints": "7,500-11,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "12,000-26,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "27,000-67,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "68,000-134,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "135,000-269,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "270,000-539,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "540,000-1,079,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,080,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}, {
			"name": "Business Rewards Options",
			"points": [{
				"bankPoints": "7,500-11,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "12,000-26,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "27,000-67,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "68,000-134,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "135,000-269,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "270,000-539,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "540,000-1,079,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,080,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}, {
			"name": "Business Black Credit Card",
			"points": [{
				"bankPoints": "7,500-11,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "12,000-26,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "27,000-67,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "68,000-134,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "135,000-269,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "270,000-539,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "540,000-1,079,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,080,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,500",
			"totalBonus": "50",
			"bonusFinePrint": "That's an extra 35% on top of the 15% Velocity Bonus"
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Bank of Queensland",
		"order": 4,
		"cards": [{
			"name": "Platinum Visa Credit Card",
			"points": [{
				"bankPoints": "30,000-46,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "47,000-117,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "940,000-1,899,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,900,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "30,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Card Services",
		"order": 5,
		"cards": [{
			"name": "Rewards Platinum MasterCard",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
	
		}, {
			"name": "Rewards Gold MasterCard",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Citibank",
		"order": 6,
		"cards": [{
			"name": "Citi Prestige Card",
			"points": [{
				"bankPoints": "20,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Citi Rewards Signature Card",
			"points": [{
				"bankPoints": "20,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Citi Business Gold Card",
			"points": [{
				"bankPoints": "20,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "20,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Citi Rewards Platinum Card",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Citi Gold Visa Card",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Commonwealth Bank",
		"order": 7,
		"cards": [{
			"name": "Platinum Awards Credit Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
	
		}, {
			"name": "Diamond Awards Credit Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Platinum Awards Credit Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Awards Credit Card",
			"points": [{
				"bankPoints": "11,000-16,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "17,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Awards Gold Credit Card",
			"points": [{
				"bankPoints": "11,000-16,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "17,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Awards Credit Card",
			"points": [{
				"bankPoints": "11,000-16,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "17,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Awards Gold Credit Card",
			"points": [{
				"bankPoints": "11,000-16,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "17,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,600",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Diners Club",
		"order": 8,
		"cards": [{
			"name": "Personal Card",
			"points": [{
				"bankPoints": "7500-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-58,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "59,000-117,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">940,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "7,500",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Business Card",
			"points": [{
				"bankPoints": "7500-10,499",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "10,500-23,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "24,000-58,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "59,000-117,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "118,000-234,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "235,000-469,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "470,000-939,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">940,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "7,500",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "HSBC",
		"order": 9,
		"cards": [{
			"name": "Premier World MasterCard",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "5,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Platinum Credit Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "5,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "NAB",
		"order": 10,
		"cards": [{
			"name": "Rewards Classic Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Rewards Platinum Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Rewards Business Platinum Card",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Bank of Melbourne",
		"order": 11,
		"cards": [{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "BankSA",
		"order": 12,
		"cards": [{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Suncorp Bank",
		"order": 13,
		"cards": [{
			"name": "Clear Options Platinum Credit Card",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Clear Options Business Credit Card",
			"points": [{
				"bankPoints": "25,000-39,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "40,000-97,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "98,000-199,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "200,000-394,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "395,000-784,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "785,000-1,599,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,600,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "25,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "St George Bank",
		"order": 14,
		"cards": [{
			"name": "Amplify Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Platinum Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Signature Credit Card Card (Auto Redeem only",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Amplify Business Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "Westpac",
		"order": 15,
		"cards": [{
			"name": "Altitude Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Platinum Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Platinum Plus Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Black Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Business Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Business Gold Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}, {
			"name": "Altitude Business Platinum Credit Card (Auto Redeem only)",
			"points": [{
				"bankPoints": "8,700-13,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "14,000-31,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "32,000-78,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "79,000-156,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "157,000-314,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "315,000-629,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "630,000-1,254,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,255,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "3,000",
			"autoRedeem": "You must set up Auto-Redemption to receive your bonus.",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	}, {
		"bank": "flybuys (inc. Coles Mastercard)",
		"order": 16,
		"cards": [{
			"name": "flybuys card",
			"points": [{
				"bankPoints": "10,000-15,999",
				"velocityPoints": "5,000-7,799"
			}, {
				"bankPoints": "16,000-35,999",
				"velocityPoints": "7,800-17,999"
			}, {
				"bankPoints": "36,000-89,999",
				"velocityPoints": "18,000-44,999"
			}, {
				"bankPoints": "90,000-179,999",
				"velocityPoints": "45,000-89,999"
			}, {
				"bankPoints": "180,000-359,999",
				"velocityPoints": "90,000-179,999"
			}, {
				"bankPoints": "360,000-719,999",
				"velocityPoints": "180,000-359,999"
			}, {
				"bankPoints": "720,000-1,439,999",
				"velocityPoints": "360,000-719,999"
			}, {
				"bankPoints": ">1,440,000",
				"velocityPoints": ">720,000"
			}],
			"minimumPoints": "2,000",
			"totalBonus": "15",
			"bonusFinePrint": ""
		}],
		"cities": ["Adelaide", "Brisbane", "Cairns", "Canberra", "Darwin", "Hobart", "Melbourne", "Perth", "Sydney"]
	
	}];
	exports.default = banks;

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	var rewards = [{
			"velocityPoints": "5,000-7,799",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Melbourne",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
	
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}, {
							"assetPath": "",
							"quantity": "$20",
							"class": "iTunes",
							"type": "Gift Card",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "For use in iTunes store only.",
							"shortTerms": "For voucher terms and conditions, see <a href='https://www.apple.com/au/shop/gift-cards' target='_blank'>Apple’s website.</a>"
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}, {
							"assetPath": "",
							"quantity": "$20",
							"class": "iTunes",
							"type": "Gift Card",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "For use in iTunes store only.",
							"shortTerms": "For voucher terms and conditions, see <a href='https://www.apple.com/au/shop/gift-cards' target='_blank'>Apple’s website.</a>"
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Geraldton",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$20 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$30 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}]
	}, {
			"velocityPoints": "7,800-17,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Melbourne",
							"airTaxes": "$23.50",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sydney",
							"airTaxes": "$22.81",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Brisbane",
							"airTaxes": "$23.18",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Sydney",
							"airTaxes": "$20.79",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Adelaide",
							"airTaxes": "$23.18",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Melbourne",
							"airTaxes": "$21.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$40 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "$28.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Melbourne",
							"airTaxes": "$31.31",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Adelaide",
							"airTaxes": "$33.01",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$40 Off",
							"class": "off",
							"type": "Fuel",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "at participating BP stations.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/Fuel/' target='_blank'>More information</a> on redeeming Velocity Points for fuel at participating BP <a href='http://apps.nowwhere.com.au/bp/sitelocator?loyalty=t' target='_blank'>service stations</a>. Redeeming Velocity Points for fuel are subject to the BP Partner <a href='https://www.velocityfrequentflyer.com/content/bp-terms/' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Sydney",
							"airTaxes": "$16.95",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Adelaide",
							"airTaxes": "$37.00",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Sydney",
							"airTaxes": "$21.11",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Hobart",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Adelaide",
							"airTaxes": "$23.50",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Geraldton",
							"airTaxes": "$37.14",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "Over halfway to a",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "$23.88",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$50 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "$18.71",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Melbourne",
							"airTaxes": "$21.11",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Brisbane",
							"airTaxes": "$20.79",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}]
	}, {
			"velocityPoints": "18,000-44,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Gold Coast",
							"airTaxes": "$21.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Adelaide",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Melbourne",
							"airTaxes": "$21.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Brisbane",
							"destination": "Cairns",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "$28.45",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Cairns",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Gold Coast",
							"airTaxes": "$28.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Canberra",
							"destination": "Adelaide",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "$40.90",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Darwin",
							"destination": "Alice Springs",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Melbourne",
							"airTaxes": "$17.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Hobart",
							"destination": "Sydney",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Gold Coast",
							"airTaxes": "$19.39",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Melbourne",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "$23.88",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Perth",
							"destination": "Broome",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Gold Coast",
							"airTaxes": "$18.71",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Sydney",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$110 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}]
	}, {
			"velocityPoints": "45,000-89,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Perth",
							"airTaxes": "$19.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Adelaide",
							"destination": "Gold Coast",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Fiji",
							"airTaxes": "$82.45",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Brisbane",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Auckland",
							"airTaxes": "$138.81",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Sunshine Coast",
							"airTaxes": "$37.46",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Hobart",
							"destination": "Brisbane",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Sydney",
							"airTaxes": "$17.47",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "1",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Perth",
							"destination": "Melbourne",
							"airTaxes": "$18.15",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "1",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Upgrade",
							"origin": "Sydney",
							"destination": "Fiji",
							"airTaxes": "",
							"disclaimer": "T&Cs apply.",
							"shortTerms": "<a href='https://www.velocityfrequentflyer.com/content/Redeem/FlightUpgrades/' target='_blank'>More information</a> on upgrading with Velocity Points. Upgrades are subject to availability and the Flight Upgrades Using Points <a href='https://www.velocityfrequentflyer.com/content/ProgramBenefits/TermsConditions/#flightupgrades' target='_blank'>Terms and Conditions.</a>"
					}, {
							"assetPath": "",
							"quantity": "$280 off",
							"class": "A Virgin Australia Flight",
							"type": "Flight Discount",
							"origin": "",
							"destination": "",
							"airTaxes": "",
							"disclaimer": "Using Points + Pay. T&Cs apply.",
							"shortTerms": "Based on a single passenger, single sector journey. Discount to be applied to base fare only, excluding other fees or charges, when you use Points to complete payment on <a href='https://www.virginaustralia.com/au/en/' target='_blank'>virginaustralia.com</a>."
					}]
			}]
	}, {
			"velocityPoints": "90,000-179,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "3",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "2",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}]
	}, {
			"velocityPoints": "180,000-359,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "6",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "4",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}]
	}, {
			"velocityPoints": "360,000-719,999",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "12",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "8",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}]
	}, {
			"velocityPoints": ">720,000",
			"rewards": [{
					"originatingPlace": "Adelaide",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Los Angeles",
							"airTaxes": "$118.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Auckland",
							"airTaxes": "$131.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Adelaide",
							"destination": "Sunshine Coast ",
							"airTaxes": "$43.33",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Brisbane",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Los Angeles",
							"airTaxes": "$104.05",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Auckland",
							"airTaxes": "$116.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Brisbane",
							"destination": "Las Vegas ",
							"airTaxes": "$117.25",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Cairns",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Melbourne",
							"airTaxes": "$28.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Sydney",
							"airTaxes": "$28.08",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Cairns",
							"destination": "Las Vegas",
							"airTaxes": "$139.91",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Canberra",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Los Angeles",
							"airTaxes": "$133.86",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Auckland",
							"airTaxes": "$145.96",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Canberra",
							"destination": "Las Vegas",
							"airTaxes": "$147.06",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
	
			}, {
					"originatingPlace": "Darwin",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Melbourne",
							"airTaxes": "$31.26",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Sydney",
							"airTaxes": "$30.58",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Darwin",
							"destination": "Hobart",
							"airTaxes": "$44.77",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Hobart",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Los Angeles",
							"airTaxes": "$113.63",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Auckland",
							"airTaxes": "$125.73",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Hobart",
							"destination": "Perth",
							"airTaxes": "$31.66",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Melbourne",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Los Angeles",
							"airTaxes": "$120.37",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Auckland",
							"airTaxes": "$113.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Melbourne",
							"destination": "Las Vegas ",
							"airTaxes": "$114.75",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
					"originatingPlace": "Perth",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "32",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Auckland",
							"airTaxes": "$134.10",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Brisbane",
							"airTaxes": "$17.83",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "24",
							"class": "Economy",
							"type": "Flight",
							"origin": "Perth",
							"destination": "Fiji",
							"airTaxes": "$100.30",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}, {
	
					"originatingPlace": "Sydney",
					"displayOptions": [{
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Los Angeles",
							"airTaxes": "$106.02",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Business",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Auckland",
							"airTaxes": "$118.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}, {
							"assetPath": "",
							"quantity": "16",
							"class": "Economy",
							"type": "Flight",
							"origin": "Sydney",
							"destination": "Las Vegas",
							"airTaxes": "$119.22",
							"disclaimer": "Fees and [x] taxes per flight apply.",
							"shortTerms": "The flights displayed are based on a one-way Virgin Australia Reward Seat on the route displayed as at 24 March 2017. Reward Seats are subject to change, availability and to the Velocity Membership Terms and Conditions and must be booked at <a href='https://www.velocityfrequentflyer.com/content/' target='_blank'>velocityfrequentflyer.com</a>. Taxes and fees are payable at the time of booking."
					}]
			}]
	}];
	exports.default = rewards;

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/* This program is free software. It comes without any warranty, to
	     * the extent permitted by applicable law. You can redistribute it
	     * and/or modify it under the terms of the Do What The Fuck You Want
	     * To Public License, Version 2, as published by Sam Hocevar. See
	     * http://www.wtfpl.net/ for more details. */
	'use strict';
	module.exports = leftPad;
	
	var cache = [
	  '',
	  ' ',
	  '  ',
	  '   ',
	  '    ',
	  '     ',
	  '      ',
	  '       ',
	  '        ',
	  '         '
	];
	
	function leftPad (str, len, ch) {
	  // convert `str` to a `string`
	  str = str + '';
	  // `len` is the `pad`'s length now
	  len = len - str.length;
	  // doesn't need to pad
	  if (len <= 0) return str;
	  // `ch` defaults to `' '`
	  if (!ch && ch !== 0) ch = ' ';
	  // convert `ch` to a `string` cuz it could be a number
	  ch = ch + '';
	  // cache common use cases
	  if (ch === ' ' && len < 10) return cache[len] + str;
	  // `pad` starts with an empty string
	  var pad = '';
	  // loop
	  while (true) {
	    // add `ch` to `pad` if `len` is odd
	    if (len & 1) pad += ch;
	    // divide `len` by 2, ditch the remainder
	    len >>= 1;
	    // "double" the `ch` so this operation count grows logarithmically on `len`
	    // each time `ch` is "doubled", the `len` would need to be "doubled" too
	    // similar to finding a value in binary search tree, hence O(log(n))
	    if (len) ch += ch;
	    // `len` is 0, exit the loop
	    else break;
	  }
	  // pad `str`!
	  return pad + str;
	}


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalculateMyBonusCTA = function CalculateMyBonusCTA(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, CalculateMyBonusCTA);
	
	  this.element = options.element;
	  this.calculatorSection = document.querySelector('#calculate-my-bonus');
	  this.scrollOptions = {
	    speed: 1000,
	    easing: 'easeOutQuart',
	    updateURL: true,
	    after: function after() {
	      _this.calculatorSection.classList.add('active');
	    }
	  };
	
	  this.element.addEventListener('click', function (e) {
	    document.body.classList.remove('locked');
	    window.smoothScroll.animateScroll(_this.calculatorSection, _this.element, _this.scrollOptions);
	  });
	};
	
	exports.default = CalculateMyBonusCTA;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(342);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Move my points.
	 * @author Dayne Coulson-Hoffacker
	 */
	var MoveMyPoints = function () {
	  /**
	   * Constructs a new counter component.
	   * @param {Object} options - Options.
	   * @param {HTMLElement} options.element - Container.
	   */
	  function MoveMyPoints(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, MoveMyPoints);
	
	    this.element = options.element;
	    this.mainQuestion = this.element.querySelector('#main-question');
	    this.header = this.element.querySelector('header');
	    this.plane = this.element.querySelector('.plane');
	    this.formWrapper = this.element.querySelector('.form-wrapper');
	    this.mainQuestionSelect = this.mainQuestion.querySelector('select');
	    this.mainQuestionEmptySpan = this.mainQuestion.querySelector('.empty');
	    this.resultQuestion = this.element.querySelector('#result-question');
	    this.resultQuestionSelect = this.resultQuestion.querySelector('select');
	    this.resultQuestionEmptySpan = this.resultQuestion.querySelector('.empty');
	    this.resultsPanel = this.element.querySelector('.results');
	    this.bankURLCta = this.resultsPanel.querySelector('.cta');
	    this.steps = this.resultsPanel.queryAll('.steps li');
	    this.step1 = this.steps[0].querySelector('span');
	    this.step2 = this.steps[1].querySelector('span');
	    this.step3 = this.steps[2].querySelector('span');
	    this.step4 = this.steps[3].querySelector('span');
	    this.step5 = this.steps[4].querySelector('span');
	    this.step6 = this.steps[5].querySelector('span');
	
	    // Fetch json file and populate drop down options
	    var url = '/content/dam/velocity/campaign/documents/may2017/movepointssteps.json';
	
	    var banks = [];
	    fetch(url, {
	      credentials: 'include'
	    }).then(function (resp) {
	      return resp.json();
	    }).then(function (data) {
	      _this.banks = data.banks.map(function (result) {
	        return JSON.parse(result);
	      });
	
	      _this.selectedBank = _this.banks.find(function (bank) {
	        return bank.bankName === _this.readCookie('BankName');
	      });
	
	      _this.createDropdown(_this.mainQuestionSelect, _this.banks);
	      _this.createDropdown(_this.resultQuestionSelect, _this.banks);
	
	      _this.updateBankCTAURL();
	      _this.updateBankSteps();
	
	      _this.resultQuestionSelect.value = _this.selectedBank.bankName || _this.readCookei('BankName');
	    }).catch(function (error) {
	      console.log(error);
	    });
	
	    // Main Question Functionality
	    this.mainQuestionSelect.addEventListener('change', function (element) {
	      _this.mainQuestionEmptySpan.innerHTML = _this.mainQuestionSelect.value;
	      _this.resultQuestionEmptySpan.innerHTML = _this.mainQuestionSelect.value;
	      _this.selectedBank = _this.banks.find(function (bank) {
	        return bank.bankName === element.target.value;
	      });
	      _this.resultQuestionSelect.value = _this.selectedBank.bankName;
	      _this.resultQuestionEmptySpan.innerHTML = _this.selectedBank.bankName;
	
	      _this.updateBankCTAURL();
	      _this.updateBankSteps();
	
	      setTimeout(function () {
	        _this.resultsPanel.classList.add('visible');
	      }, 500);
	    });
	
	    // Result Question Functionality
	    this.resultQuestionSelect.addEventListener('change', function (element) {
	      _this.selectedBank = _this.banks.find(function (bank) {
	        return bank.bankName === element.target.value;
	      });
	      _this.resultQuestionEmptySpan.innerHTML = _this.resultQuestionSelect.value;
	      _this.mainQuestionEmptySpan.innerHTML = _this.resultQuestionSelect.value;
	
	      _this.updateBankCTAURL();
	      _this.updateBankSteps();
	    });
	
	    // If calculatorCompleted cookie present, enable results section
	    if (this.readCookie('BankName')) {
	      this.resultQuestionSelect.value = this.readCookie('BankName');
	      this.resultQuestionEmptySpan.innerHTML = this.readCookie('BankName');
	      this.header.classList.add('hidden');
	      this.plane.classList.add('hidden');
	      this.formWrapper.classList.add('hidden');
	      this.resultsPanel.classList.add('visible');
	      this.updateBankCTAURL();
	      this.updateBankSteps();
	    }
	  }
	
	  // Update Bank CTA URL
	
	
	  (0, _createClass3.default)(MoveMyPoints, [{
	    key: 'updateBankCTAURL',
	    value: function updateBankCTAURL() {
	      if (this.selectedBank) {
	        this.bankURLCta.setAttribute('href', this.selectedBank.bankUrl);
	      }
	    }
	
	    // Update bank steps on page load and also on dropdown change.
	
	  }, {
	    key: 'updateBankSteps',
	    value: function updateBankSteps() {
	      var _this2 = this;
	
	      if (this.selectedBank) {
	        this.selectedBank.steps.forEach(function (step, index) {
	          if (index === 0) {
	            _this2.step1.innerHTML = step.stepDescr;
	          } else if (index === 1) {
	            _this2.step2.innerHTML = step.stepDescr;
	          } else if (index === 2) {
	            _this2.step3.innerHTML = step.stepDescr;
	          } else if (index === 3) {
	            _this2.step4.innerHTML = step.stepDescr;
	          } else if (index === 4) {
	            _this2.step5.innerHTML = step.stepDescr;
	          } else if (index === 5) {
	            _this2.step6.innerHTML = step.stepDescr;
	          }
	        });
	      }
	    }
	  }, {
	    key: 'createDropdown',
	    value: function createDropdown(select, banks) {
	      var _this3 = this;
	
	      banks.forEach(function (bank) {
	        var option = _this3.createNode('option');
	        option.value = '' + bank.bankName;
	        option.innerHTML = '' + bank.bankName;
	        _this3.append(select, option);
	      });
	    }
	
	    // Read cookie
	
	  }, {
	    key: 'readCookie',
	    value: function readCookie(name) {
	      var nameEQ = name + '=';
	      var ca = document.cookie.split(';');
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1, c.length);
	        }
	        if (c.indexOf(nameEQ) === 0) {
	          return c.substring(nameEQ.length, c.length);
	        }
	      }
	      return null;
	    }
	
	    // Create node function
	
	  }, {
	    key: 'createNode',
	    value: function createNode(element) {
	      return document.createElement(element);
	    }
	
	    // Append function
	
	  }, {
	    key: 'append',
	    value: function append(parent, el) {
	      return parent.appendChild(el);
	    }
	  }]);
	  return MoveMyPoints;
	}();
	
	exports.default = MoveMyPoints;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(370)))

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = global.fetch;
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(339);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Video module.
	 * @author Dayne Coulson-Hoffacker
	 */
	var VideoModule =
	/**
	 * Constructs a new counter component.
	 * @param {Object} options - Options.
	 * @param {HTMLElement} options.element - Container.
	 */
	function VideoModule(options) {
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, VideoModule);
	
	  this.element = options.element;
	  this.cta = this.element.querySelector('.cta');
	  this.videoContainer = document.querySelector('.video-player');
	  this.closeButton = this.videoContainer.querySelector('.close-icon');
	  this.MoveMyPointsSection = document.querySelector('#move-my-points');
	  this.video = this.element.querySelector('video');
	
	  this.cta.addEventListener('click', function () {
	    _this.videoContainer.classList.add('visible');
	    document.body.classList.add('locked');
	    if (_this.MoveMyPointsSection) {
	      _this.MoveMyPointsSection.classList.add('locked');
	    }
	  });
	
	  this.closeButton.addEventListener('click', function () {
	    _this.videoContainer.classList.remove('visible');
	    document.body.classList.remove('locked');
	    _this.video.pause();
	    _this.video.currentTime = 0;
	  });
	};
	
	exports.default = VideoModule;

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js